import React from 'react';
import { colors } from '@keen.io/colors';

var ArrowUp = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 24 30"
  }, React.createElement("polygon", {
    fill: fill,
    fillRule: "evenodd",
    points: "10.768 0 10.768 23.16 3.245 15.637 .776 18.106 12.414 29.744 24.052 18.106 21.583 15.637 14.06 23.16 14.06 0",
    transform: "matrix(1 0 0 -1 0 29.744)"
  }));
};

var ArrowDown = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 24 30"
  }, React.createElement("polygon", {
    fill: fill,
    fillRule: "evenodd",
    points: "10.768 0 10.768 23.16 3.245 15.637 .776 18.106 12.414 29.744 24.052 18.106 21.583 15.637 14.06 23.16 14.06 0",
    transform: "translate(0 .256)"
  }));
};

var LineWidget$1 = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M7.92079208,0 L7.92079208,92.0792079 L100,92.0792079 L100,100 L3.96039604,100 L0,96.039604 L0,0 L7.92079208,0 Z M54.8219875,12 C57.7417307,12 59.8798629,13.775612 61.5191033,16.6442909 C62.4449319,18.2644957 63.2057076,20.163164 64.1504852,23.0198069 L64.1504852,23.0198069 L64.4397876,23.9062186 C64.6134797,24.4448967 65.256983,26.4863974 65.6300246,27.6595078 L65.6300246,27.6595078 L65.972662,28.7234646 C68.426891,36.2027609 70.423638,39.2349743 72.6896356,39.2349743 C74.9625869,39.2349743 77.6813577,37.1124488 80.9001777,32.9188098 C81.3089386,32.3862558 85.5335803,26.3796102 86.5878928,25.3271546 C87.3350667,24.5812967 88.0819734,24.0516493 89.0746705,23.777287 C90.8668253,23.2819701 92.6825122,23.9801069 93.7547701,25.5269995 C94.725274,26.9270967 94.9612191,28.6068295 94.9611737,31.3840866 L94.9611737,31.3840866 L94.9656067,32.3681685 C94.9971299,39.6972919 95.0069814,49.5019303 94.9951705,61.7831654 L94.9951705,61.7831654 L94.9612086,82.062601 L91.1494542,86 L17.81176,86 L14,82.0470021 C14.0085239,76.5455358 14.0136019,71.5455646 14.0152343,67.0458943 L14.0152343,67.0458943 L14,50.4083707 C14.0051434,47.8471276 14.1849723,46.2056566 14.7705711,44.8885853 C16.0879858,41.9255853 19.1177042,41.3490507 21.5190771,42.8978336 C22.7001484,43.6595741 26.9425596,48.3315358 27.3882678,48.7645949 L27.3882678,48.7645949 L27.7078826,49.0707381 C30.683516,51.8795455 33.4562396,53.3284708 36.4778687,53.3284708 C39.1601315,53.3284708 41.6573394,48.0765439 43.9942134,36.8179847 L43.9942134,36.8179847 L44.1999927,35.8089751 L45.8795521,27.0840195 C46.6802335,23.0525285 47.3204354,20.4452533 48.1050053,18.2978688 C49.5260639,14.4084015 51.4588955,12 54.8219875,12 Z"
  }));
};

var AlignCenter = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M96,87 L100,91 L100,96 L96,100 L4,100 L0,96 L0,91 L4,87 L96,87 Z M60,58 L64,62 L64,67 L60,71 L4,71 L0,67 L0,62 L4,58 L60,58 Z M96,29 L100,33 L100,38 L96,42 L4,42 L0,38 L0,33 L4,29 L96,29 Z M60,0 L64,4 L64,9 L60,13 L4,13 L0,9 L0,4 L4,0 L60,0 Z"
  }));
};

var AlignLeft = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M96,87 L100,91 L100,96 L96,100 L4,100 L0,96 L0,91 L4,87 L96,87 Z M78,58 L82,62 L82,67 L78,71 L22,71 L18,67 L18,62 L22,58 L78,58 Z M96,29 L100,33 L100,38 L96,42 L4,42 L0,38 L0,33 L4,29 L96,29 Z M78,0 L82,4 L82,9 L78,13 L22,13 L18,9 L18,4 L22,0 L78,0 Z"
  }));
};

var AlignRight = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M96,87 L100,91 L100,96 L96,100 L4,100 L0,96 L0,91 L4,87 L96,87 Z M96,58 L100,62 L100,67 L96,71 L40,71 L36,67 L36,62 L40,58 L96,58 Z M96,29 L100,33 L100,38 L96,42 L4,42 L0,38 L0,33 L4,29 L96,29 Z M96,0 L100,4 L100,9 L96,13 L40,13 L36,9 L36,4 L40,0 L96,0 Z"
  }));
};

var ButtonArrow = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M73.31 23l26.662 26.662-27.266 27.266-2.51-2.51 23.384-23.39H0v-4h92.198l-21.456-21.46L73.309 23z"
  }));
};

var ButtonArrowLeft = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    transform: "rotate(180 50 50)",
    d: "M73.31 23l26.662 26.662-27.266 27.266-2.51-2.51 23.384-23.39H0v-4h92.198l-21.456-21.46L73.309 23z"
  }));
};

var Brand = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 143 120"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fill: fill
  }, React.createElement("path", {
    d: "M57.6 69 64.385 80.349 47.423 108.72 135.485 108.72 142.2 120 27 120z"
  }), React.createElement("path", {
    d: "M0 120 13.462 120 57.667 45.297 74.599 74.013 88.2 74.013 57.737 22.2z"
  }), React.createElement("path", {
    d: "M64.2 11.383 108.083 86.278 74.289 86.278 67.518 97.8 128.4 97.8 70.904 0z"
  }))));
};

var BoldText = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M50.8734587,100 C58.1266488,100 64.1150078,99.3731811 68.8385359,98.1195433 C73.562064,96.8659055 77.8938303,94.761585 81.8338348,91.8065816 C85.2365659,89.299306 87.9117394,86.1428252 89.8593553,82.337139 C91.8069711,78.5314529 92.780779,74.2108798 92.780779,69.3754197 C92.780779,62.7042758 90.8667428,57.3315424 87.0386702,53.2572196 C83.2105977,49.1828968 78.0281486,46.4965301 71.491323,45.1981195 L71.491323,45.1981195 L71.491323,44.6608462 C76.147692,42.6012984 79.7519006,39.7246474 82.303949,36.0308932 C84.8559973,32.337139 86.1320215,28.0725319 86.1320215,23.2370719 C86.1320215,19.0732035 85.2029863,15.3682561 83.3449161,12.1222297 C81.4868458,8.87620327 78.6549675,6.29057533 74.8492814,4.36534587 C71.1779136,2.52966197 67.4729662,1.34318334 63.7344392,0.805910007 C59.9959122,0.268636669 54.0970987,0 46.0379987,0 L7.22,0 L7.22,100 L50.8734587,100 Z M37.6612042,39.4888033 L32.8748019,39.4895903 L32.8748019,18.3344527 L35.9190593,18.3344527 C40.6772941,18.3373092 44.3972629,18.3708305 47.0789657,18.4351914 C49.8772644,18.5023506 52.216642,18.8941124 54.0970987,19.6104768 C56.2014193,20.4163868 57.6677278,21.6476382 58.4960242,23.304231 C59.3243206,24.9608238 59.7384688,26.6174166 59.7384688,28.2740094 C59.7384688,30.4231028 59.3802865,32.3147526 58.6639221,33.948959 C57.9475576,35.5831654 56.4252832,36.9151556 54.0970987,37.9449295 C52.4405059,38.7060667 50.1794806,39.1537945 47.3140228,39.2881128 C44.448565,39.4224312 40.9786747,39.4895903 36.9043519,39.4895903 L37.6612042,39.4888033 Z M36.627117,81.6650245 L32.8748019,81.6655473 L32.8748019,56.7494963 L38.5161719,56.7494963 C42.3666308,56.7494963 46.060385,56.7718827 49.5974345,56.8166555 C53.134484,56.8614283 55.9103962,57.1748377 57.9251713,57.7568838 C60.8801746,58.6075666 62.973302,59.894784 64.2045534,61.6185359 C65.4358048,63.3422879 66.0514305,65.7935975 66.0514305,68.9724647 C66.0514305,71.3901948 65.5477367,73.5280949 64.5403492,75.3861652 C63.5329617,77.2442355 61.6860846,78.7329304 58.9997179,79.8522498 C56.358124,80.9715693 53.4702798,81.5536154 50.3361854,81.5983882 C47.4786286,81.6392104 42.9089392,81.6614225 36.627117,81.6650245 L36.627117,81.6650245 Z"
  }));
};

var BarHorizontal = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M18.9104478,55.2238806 L18.9104478,100 L1,100 L1,55.2238806 L18.9104478,55.2238806 Z M100.004975,0 L100.004975,99.5024876 L82.0945274,99.5024876 L82.0945274,0 L100.004975,0 Z M46.2736318,19.9004975 L46.2736318,99.5024876 L28.3631841,99.5024876 L28.3631841,19.9004975 L46.2736318,19.9004975 Z M73.1393035,69.6517413 L73.1393035,99.5024876 L55.2288557,99.5024876 L55.2288557,69.6517413 L73.1393035,69.6517413 Z",
    transform: "scale(1 -1) rotate(90 100.502 0)"
  }));
};

var BarVertical = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M99.009901,0 L99.009901,100 L81.1881188,100 L81.1881188,0 L99.009901,0 Z M44.5544554,19.8019802 L44.5544554,100 L26.7326733,100 L26.7326733,19.8019802 L44.5544554,19.8019802 Z M17.8217822,55.4455446 L17.8217822,100 L0,100 L0,55.4455446 L17.8217822,55.4455446 Z M72.2772277,70.2970297 L72.2772277,100 L54.4554455,100 L54.4554455,70.2970297 L72.2772277,70.2970297 Z"
  }));
};

var CaretLeft = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 30 30"
  }, React.createElement("polygon", {
    fill: fill,
    points: "20.55 0 24.453519 3.90351896 13.3573737 15 24.453519 26.096481 20.55 30 5.55 15"
  }));
};

var CaretRight = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 30 30"
  }, React.createElement("polygon", {
    fill: fill,
    points: "9.45351896 0 24.453519 15 9.45351896 30 5.55 26.096481 16.6465765 15 5.55 3.90351896"
  }));
};

var CaretUp = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 30 30"
  }, React.createElement("polygon", {
    fill: fill,
    points: "15 5.55 30 20.55 26.096481 24.453519 15.0000667 13.3569503 3.90351896 24.453519 0 20.55"
  }));
};

var CaretDown = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 30 30"
  }, React.createElement("polygon", {
    fill: fill,
    points: "26.096481 5.55 30 9.45351896 15 24.453519 0 9.45351896 3.90351896 5.55 15 16.6465687"
  }));
};

var Clone = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M20,30 L20,66 L34,80 L70,80 L70,90 L60,100 L10,100 L0,90 L0,40 L10,30 L20,30 Z M90,0 L100,10 L100,60 L90,70 L40,70 L30,60 L30,10 L40,0 L90,0 Z"
  }));
};

var Close = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 98 96"
  }, React.createElement("path", {
    fill: "none",
    stroke: fill,
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M1.083.083l95.834 95.834m0-95.834L1.083 95.917"
  }));
};

var CornerTick = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("polygon", {
    fill: fill,
    points: "47.07 2.881 30.519 9.734 30.519 126.028 47.07 132.881 105.243 74.734 105.243 61.028",
    transform: "rotate(45 67.881 67.881)"
  }));
};

var ChoroplethWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M3.61527814,68.8207438 C3.74444435,68.8606174 3.87442868,68.900286 4.00522743,68.9397529 L4.00522743,68.9397529 L4.85369982,69.1896969 C4.99695433,69.230905 5.14112706,69.2718912 5.2862135,69.3126593 L5.2862135,69.3126593 L6.16766078,69.5546804 L7.07082116,69.7916506 L7.99547849,70.0237547 L8.94141665,70.2511772 L9.90841951,70.474103 C15.0943225,71.6452278 21.1254756,72.5698314 27.6970141,73.2120331 C30.997341,86.5538692 37.054624,96.5366827 44.329132,100.000477 C25.8185399,97.8973619 10.3689112,85.6224443 3.63107742,68.8619214 Z M55.7162463,99.994984 L55.670868,100.000477 C62.9393731,96.539541 68.9926612,86.5703405 72.2952019,73.245391 C78.9963834,72.6010802 85.144243,71.6650629 90.4179783,70.474103 L90.4179783,70.474103 L91.3849812,70.2511772 L92.3309193,70.0237547 L93.2555767,69.7916506 L94.158737,69.5546804 L95.0401843,69.3126593 C95.1852708,69.2718912 95.3294435,69.230905 95.472698,69.1896969 L95.472698,69.1896969 L96.3211704,68.9397529 C96.3268737,68.938032 96.3325755,68.9363107 96.3382757,68.934589 C89.5916807,85.6443278 74.1800449,97.8801561 55.7162463,99.994984 Z M38.2698676,73.9761593 C42.1358788,74.1631489 46.1170913,74.259604 50.1631989,74.259604 C54.0939108,74.259604 57.9633764,74.1685722 61.7254721,73.9919372 C60.8639141,76.8583196 59.8488798,79.5019679 58.6984623,81.8638281 C55.5437953,88.3405052 52.1786508,91.2626799 50,91.2626799 C47.8213492,91.2626799 44.4562047,88.3405052 41.3015377,81.8638281 C40.1500433,79.4997569 39.1341856,76.8533698 38.2728003,73.984433 Z M35.2952252,42.4824128 C38.2783391,42.6896991 41.3694312,42.8315036 44.548399,42.9071888 L44.548399,42.9071888 L46.3722523,42.9432029 C47.5943316,42.9624199 48.8285805,42.9720459 50.0738916,42.9720459 C51.3192026,42.9720459 52.5534516,42.9624199 53.7755309,42.9432029 L53.7755309,42.9432029 L55.5993842,42.9071888 C58.7262849,42.8327432 61.7681651,42.6943265 64.7058936,42.4925453 L64.7567774,43.174487 C64.9172578,45.4072435 65,47.6878663 65,50.0004773 C65,54.8049121 64.6428862,59.4712863 63.973527,63.8572305 L63.3649425,63.8936524 L61.5312701,63.989622 C57.8436373,64.1673707 54.0371339,64.259604 50.1631989,64.259604 C46.2892639,64.259604 42.4827605,64.1673707 38.7951277,63.989622 L38.7951277,63.989622 L36.9614553,63.8936524 L36.0234241,63.8372364 C35.3560294,59.4571057 35,54.7976122 35,50.0004773 C35,47.6878663 35.0827422,45.4072435 35.2432226,43.174487 Z M100,50.0004773 C100,52.2998834 99.8467502,54.5632672 99.5499688,56.7808482 C99.3232123,56.9214681 99.0675025,57.06902 98.7833401,57.2207396 C97.354733,57.9834995 95.4293961,58.7367819 93.0781157,59.4476482 L93.0781157,59.4476482 L92.1765577,59.7121705 C92.0230165,59.7559047 91.8678459,59.7994571 91.7110634,59.8428198 L91.7110634,59.8428198 L90.7511624,60.1006535 C90.588001,60.1432248 90.4232622,60.1855901 90.2569632,60.2277415 L90.2569632,60.2277415 L89.2405858,60.4780182 C88.8956448,60.5605452 88.5446016,60.642152 88.1875942,60.7227745 C84.0848502,61.6492911 79.3556776,62.4144858 74.1920844,62.9932827 C74.7192957,58.8439941 75,54.4895366 75,50.0004773 C75,47.1084896 74.8834986,44.272366 74.6596054,41.5108092 C84.3646376,40.2342425 92.3887446,38.1253085 97.8062585,35.2144963 C99.232479,39.8891007 100,44.8545837 100,50.0004773 Z M2.21555363,35.1464124 C7.60697396,38.0775947 15.6263174,40.2027912 25.3414969,41.4924427 C25.1170653,44.2586553 25,47.1014991 25,50.0004773 C25,54.4758669 25.2789973,58.8174732 25.8032317,62.9559849 C20.7683544,62.3816218 16.1536428,61.6294396 12.1388036,60.7227745 C11.7817963,60.642152 11.430753,60.5605452 11.0858121,60.4780182 L11.0858121,60.4780182 L10.0694346,60.2277415 C9.90313562,60.1855901 9.73839679,60.1432248 9.57523539,60.1006535 L9.57523539,60.1006535 L8.61533445,59.8428198 C8.45855191,59.7994571 8.30338136,59.7559047 8.1498401,59.7121705 L8.1498401,59.7121705 L7.24828211,59.4476482 C4.89700173,58.7367819 2.97166488,57.9834995 1.54305768,57.2207396 C1.22944201,57.0532943 0.950482803,56.8909255 0.706895719,56.7366853 L0.706895719,56.7366853 L0.419088275,56.5454421 C0.142603906,54.4031599 0,52.2185786 0,50.0004773 C0,44.9981269 0.725298705,40.1662624 2.07583482,35.6055851 Z M50,8.73827464 C52.1786508,8.73827464 55.5437953,11.6604493 58.6984623,18.1371264 C60.6769347,22.1990216 62.2549889,27.0943514 63.3370856,32.5199646 C59.0886084,32.8167606 54.6332972,32.9720459 50.0738916,32.9720459 C45.4624518,32.9720459 40.9574959,32.8131959 36.6656003,32.5109472 C37.7467503,27.0889567 39.3241555,22.1967834 41.3015377,18.1371264 C44.4562047,11.6604493 47.8213492,8.73827464 50,8.73827464 Z M93.9516041,25.9897918 L93.8788561,26.0332739 C91.8296175,27.2368131 88.5901434,28.4279588 84.4349012,29.4601681 C81.1435146,30.277786 77.4012355,30.9691819 73.330899,31.5165478 C70.3782577,15.8249615 63.7791601,3.85837452 55.6668584,-0.00143124652 C72.2258835,1.88008719 86.3358688,11.9001185 93.9516041,25.9897918 Z M44.3331416,-0.00143124652 C36.2242875,3.85673417 29.6273515,15.8147918 26.6740113,31.4963089 C22.6579343,30.952781 18.9652723,30.2680989 15.712882,29.4601681 C11.5576398,28.4279588 8.31816565,27.2368131 6.26892705,26.0332739 C6.20574203,25.9961647 6.14423428,25.9593569 6.08440717,25.9228849 C13.7012812,11.882452 27.7720725,1.89720458 44.2837537,0.00597055916 Z"
  }));
};

var DatePicker = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M16.6666667,0 L16.6666667,10 L11.1111111,10 C5,10 0,14.5 0,20 L0,90 C0,95.5 5,100 11.1111111,100 L88.8888889,100 C95,100 100,95.5 100,90 L100,20 C100,14.5 95,10 88.8888889,10 L83.3333333,10 L83.3333333,0 L72.2222222,0 L72.2222222,10 L27.7777778,10 L27.7777778,0 L16.6666667,0 Z M11.1111111,35 L88.8888889,35 L88.8888889,90 L11.1111111,90 L11.1111111,35 Z"
  }));
};

var Delete = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M85,30 L85,92 C85,96.1140137 81.0759277,100 77,100 L23,100 C19.0268555,100 15,96.1140137 15,92 L15,30 L85,30 Z M30,39 C27.5837542,39 25.6122919,41.0375701 25.5046306,43.59442 L25.5,43.8148148 L25.5,86.1851852 C25.5,88.844334 27.5147186,91 30,91 C32.4162458,91 34.3877081,88.9624299 34.4953694,86.40558 L34.5,86.1851852 L34.5,43.8148148 C34.5,41.155666 32.4852814,39 30,39 Z M50,39 C47.5837542,39 45.6122919,41.0375701 45.5046306,43.59442 L45.5,43.8148148 L45.5,86.1851852 C45.5,88.844334 47.5147186,91 50,91 C52.4162458,91 54.3877081,88.9624299 54.4953694,86.40558 L54.5,86.1851852 L54.5,43.8148148 C54.5,41.155666 52.4852814,39 50,39 Z M70,39 C67.5837542,39 65.6122919,41.0375701 65.5046306,43.59442 L65.5,43.8148148 L65.5,86.1851852 C65.5,88.844334 67.5147186,91 70,91 C72.4162458,91 74.3877081,88.9624299 74.4953694,86.40558 L74.5,86.1851852 L74.5,43.8148148 C74.5,41.155666 72.4852814,39 70,39 Z M50,0 C56.627417,0 62,5.372583 62,12 L86.5,12 C90.0898509,12 93,14.9101491 93,18.5 C93,22.0898509 90.0898509,25 86.5,25 L13.5,25 C9.91014913,25 7,22.0898509 7,18.5 C7,14.9101491 9.91014913,12 13.5,12 L38,12 C38,5.372583 43.372583,0 50,0 Z"
  }));
};

var DonutWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M44.3824429,-1.42108547e-14 L45.681186,12.2547016 C27.4847562,14.1831443 12.3233293,30.1481773 12.3233293,49.8390234 C12.3233293,70.7431259 29.2694526,87.6892492 50.1735551,87.6892492 C69.4487285,87.6892492 86.0434168,71.9977234 87.6694713,55.1037595 L87.7141513,54.5914681 L100,55.5518671 C98.1697697,78.9649817 76.1692739,100.012579 50.1735551,100.012579 C22.4634658,100.012579 -3.97903932e-13,77.5491128 -3.97903932e-13,49.8390234 C-4.12114787e-13,23.9583739 19.6567014,3.00099533 43.653941,0.0828921868 L44.3824429,-1.42108547e-14 Z M55.1163646,0.0189088789 C78.2399338,1.83465486 97.9057876,21.2678964 99.9281559,44.2671032 L99.9840247,44.9651259 L87.692646,45.8519488 C86.463621,28.8176446 71.7521577,13.9629029 54.6700167,12.3492545 L54.1516619,12.3044205 L55.1163646,0.0189088789 Z"
  }));
};

var Drag = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M38.3333333,0 C39.2538079,0 40,0.746192084 40,1.66666667 L40,18.3333333 C40,19.2538079 39.2538079,20 38.3333333,20 L21.6666667,20 C20.7461921,20 20,19.2538079 20,18.3333333 L20,1.66666667 C20,0.746192084 20.7461921,0 21.6666667,0 L38.3333333,0 Z M38.3333333,40 C39.2538079,40 40,40.7461921 40,41.6666667 L40,58.3333333 C40,59.2538079 39.2538079,60 38.3333333,60 L21.6666667,60 C20.7461921,60 20,59.2538079 20,58.3333333 L20,41.6666667 C20,40.7461921 20.7461921,40 21.6666667,40 L38.3333333,40 Z M38.3333333,80 C39.2538079,80 40,80.7461921 40,81.6666667 L40,98.3333333 C40,99.2538079 39.2538079,100 38.3333333,100 L21.6666667,100 C20.7461921,100 20,99.2538079 20,98.3333333 L20,81.6666667 C20,80.7461921 20.7461921,80 21.6666667,80 L38.3333333,80 Z M78.3333333,0 C79.2538079,0 80,0.746192084 80,1.66666667 L80,18.3333333 C80,19.2538079 79.2538079,20 78.3333333,20 L61.6666667,20 C60.7461921,20 60,19.2538079 60,18.3333333 L60,1.66666667 C60,0.746192084 60.7461921,0 61.6666667,0 L78.3333333,0 Z M78.3333333,40 C79.2538079,40 80,40.7461921 80,41.6666667 L80,58.3333333 C80,59.2538079 79.2538079,60 78.3333333,60 L61.6666667,60 C60.7461921,60 60,59.2538079 60,58.3333333 L60,41.6666667 C60,40.7461921 60.7461921,40 61.6666667,40 L78.3333333,40 Z M78.3333333,80 C79.2538079,80 80,80.7461921 80,81.6666667 L80,98.3333333 C80,99.2538079 79.2538079,100 78.3333333,100 L61.6666667,100 C60.7461921,100 60,99.2538079 60,98.3333333 L60,81.6666667 C60,80.7461921 60.7461921,80 61.6666667,80 L78.3333333,80 Z"
  }));
};

var QuestionMark = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 20 20"
  }, React.createElement("path", {
    fill: fill,
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,2.22222222 C5.70445195,2.22222222 2.22222222,5.70445195 2.22222222,10 C2.22222222,14.2955481 5.70445195,17.7777778 10,17.7777778 C14.2955481,17.7777778 17.7777778,14.2955481 17.7777778,10 C17.7777778,5.70445195 14.2955481,2.22222222 10,2.22222222 Z M10.4726667,11.564 L10.656,10.5153333 C10.6853333,10.3637778 10.7623333,10.2256667 10.887,10.101 C11.0116667,9.97633333 11.1595556,9.85044444 11.3306667,9.72333333 C11.5017778,9.59622222 11.6826667,9.45933333 11.8733333,9.31266667 C12.064,9.166 12.2387778,8.99244444 12.3976667,8.792 C12.5565556,8.59155556 12.6885556,8.35566667 12.7936667,8.08433333 C12.8987778,7.813 12.9513333,7.49155556 12.9513333,7.12 C12.9513333,6.73377778 12.8816667,6.38422222 12.7423333,6.07133333 C12.603,5.75844444 12.4062222,5.49077778 12.152,5.26833333 C11.8977778,5.04588889 11.5922222,4.87477778 11.2353333,4.755 C10.8784444,4.63522222 10.48,4.57533333 10.04,4.57533333 C9.72222222,4.57533333 9.42522222,4.60344444 9.149,4.65966667 C8.87277778,4.71588889 8.61611111,4.79288889 8.379,4.89066667 C8.14188889,4.98844444 7.92188889,5.10333333 7.719,5.23533333 C7.51611111,5.36733333 7.32666667,5.50911111 7.15066667,5.66066667 L7.15066667,5.66066667 L7.686,6.49666667 C7.77888889,6.658 7.91822222,6.73866667 8.104,6.73866667 C8.18711111,6.73866667 8.27511111,6.70933333 8.368,6.65066667 C8.46088889,6.592 8.57333333,6.52722222 8.70533333,6.45633333 C8.83733333,6.38544444 8.995,6.32066667 9.17833333,6.262 C9.36166667,6.20333333 9.58777778,6.174 9.85666667,6.174 C10.2233333,6.174 10.5178889,6.26933333 10.7403333,6.46 C10.9627778,6.65066667 11.074,6.90733333 11.074,7.23 C11.074,7.494 11.0165556,7.72255556 10.9016667,7.91566667 C10.7867778,8.10877778 10.645,8.28233333 10.4763333,8.43633333 C10.3076667,8.59033333 10.1267778,8.73455556 9.93366667,8.869 C9.74055556,9.00344444 9.56577778,9.14277778 9.40933333,9.287 C9.25288889,9.43122222 9.12822222,9.59011111 9.03533333,9.76366667 C8.94244444,9.93722222 8.91311111,10.1413333 8.94733333,10.376 L8.94733333,10.376 L9.08666667,11.564 L10.4726667,11.564 Z M9.71733333,15.436 C9.88355556,15.436 10.04,15.4066667 10.1866667,15.348 C10.3333333,15.2893333 10.4604444,15.2074444 10.568,15.1023333 C10.6755556,14.9972222 10.7598889,14.8737778 10.821,14.732 C10.8821111,14.5902222 10.9126667,14.4362222 10.9126667,14.27 C10.9126667,14.1086667 10.8821111,13.9558889 10.821,13.8116667 C10.7598889,13.6674444 10.6755556,13.5427778 10.568,13.4376667 C10.4604444,13.3325556 10.3333333,13.2494444 10.1866667,13.1883333 C10.04,13.1272222 9.88355556,13.0966667 9.71733333,13.0966667 C9.54622222,13.0966667 9.38855556,13.1272222 9.24433333,13.1883333 C9.10011111,13.2494444 8.97422222,13.3325556 8.86666667,13.4376667 C8.75911111,13.5427778 8.67477778,13.6674444 8.61366667,13.8116667 C8.55255556,13.9558889 8.522,14.1086667 8.522,14.27 C8.522,14.4362222 8.55255556,14.5902222 8.61366667,14.732 C8.67477778,14.8737778 8.75911111,14.9972222 8.86666667,15.1023333 C8.97422222,15.2074444 9.10011111,15.2893333 9.24433333,15.348 C9.38855556,15.4066667 9.54622222,15.436 9.71733333,15.436 Z"
  }));
};

var Resize = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M64.9077085,54.3029844 L83.1259844,72.5229844 L93.6310882,62.0188658 L99.992975,64.6552164 L100,96.2744639 L96.2744639,100 L64.6552164,99.992975 L62.0188658,93.6310882 L72.5229844,83.1259844 L54.3029844,64.9077085 L54.3029844,58.2510202 L58.2510202,54.3029844 L64.9077085,54.3029844 Z M3.72553614,9.97140148e-11 L35.3447836,0.00702502695 L37.9811342,6.36891178 L27.476,16.873 L45.7672309,35.1625067 L45.7672309,41.819195 L41.819195,45.7672309 L35.1625067,45.7672309 L16.873,27.476 L6.36891178,37.9811342 L0.00702502696,35.3447836 L1.13615783e-10,3.72553614 L3.72553614,9.97140148e-11 Z"
  }));
};

var EyeSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M50,17.5 C64.8055528,17.5 80.9221788,27.7655096 99.0173345,47.6535193 L99.5662788,48.2591309 L88.4337212,58.3122977 L88.3920726,58.2687244 C74.1851848,71.9986129 61.4591056,78.9665587 50,78.9665587 C38.5407512,78.9665587 25.8144972,71.9984388 11.6073949,58.2682098 L11.5662788,58.3122977 L0.4337212,48.2591309 C18.752099,27.973941 35.0448962,17.5 50,17.5 Z M50,32.5 C41.5008572,32.5 30.3769173,38.9975164 17.0975591,52.4447361 C29.9267681,64.8604634 40.9643661,70.9665587 50,70.9665587 C59.0357478,70.9665587 70.0735103,64.8603094 82.9037721,52.445969 C69.6237348,38.9978973 58.4993919,32.5 50,32.5 Z M49.5714285,38 C57.0667215,38 63.142857,44.0761355 63.142857,51.5714285 C63.142857,59.0667215 57.0667215,65.142857 49.5714285,65.142857 C42.0761355,65.142857 36,59.0667215 36,51.5714285 C36,44.0761355 42.0761355,38 49.5714285,38 Z"
  }));
};

var EyeOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M50,16.5 C64.1635907,16.5 80.5180835,26.9225508 99.2859637,47.5533159 L99.8554263,48.1816151 L96.6721209,51.056348 C78.7970488,70.3137448 63.2669794,79.9818994 50,79.9818994 C36.7337065,79.9818994 21.2045571,70.3147445 3.33065177,51.0593349 L0.144573733,48.1816151 L1.28202148,46.9312661 C19.8120868,26.7130577 35.9794759,16.5 50,16.5 Z M50,21.5 C37.763248,21.5 22.7474241,30.9630338 5.16560765,50.0943767 C22.536631,68.7124396 37.5077908,77.9818994 50,77.9818994 C62.4924634,77.9818994 77.4639782,68.7120624 94.8344504,50.0952278 C77.2521423,30.9627606 62.2365753,21.5 50,21.5 Z M49.5324675,29.4415584 C60.9798241,29.4415584 70.2597402,38.7214745 70.2597402,50.1688311 C70.2597402,61.6161877 60.9798241,70.8961038 49.5324675,70.8961038 C38.0851108,70.8961038 28.8051947,61.6161877 28.8051947,50.1688311 C28.8051947,38.7214745 38.0851108,29.4415584 49.5324675,29.4415584 Z M49.5324675,31.4415584 C39.1896803,31.4415584 30.8051947,39.826044 30.8051947,50.1688311 C30.8051947,60.5116182 39.1896803,68.8961038 49.5324675,68.8961038 C59.8752546,68.8961038 68.2597402,60.5116182 68.2597402,50.1688311 C68.2597402,39.826044 59.8752546,31.4415584 49.5324675,31.4415584 Z M49.5324675,42.5324675 C53.7499146,42.5324675 57.1688311,45.9513839 57.1688311,50.1688311 C57.1688311,54.3862783 53.7499146,57.8051947 49.5324675,57.8051947 C45.3150203,57.8051947 41.8961038,54.3862783 41.8961038,50.1688311 C41.8961038,45.9513839 45.3150203,42.5324675 49.5324675,42.5324675 Z"
  }));
};

var EyeSlashSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M90.0251263,7.02512627 L94.9748737,11.9748737 L9.97487373,96.9748737 L5.02512627,92.0251263 L90.0251263,7.02512627 Z M82.3699349,31.6499245 C87.7341105,36.002112 93.2761377,41.3434892 99.0173345,47.6535193 L99.5662788,48.2591309 L88.4337212,58.3122977 L88.3920726,58.2687244 C74.1851848,71.9986129 61.4591056,78.9665587 50,78.9665587 C46.0145098,78.9665587 41.8757594,78.1236767 37.5747522,76.4465795 L43.9026587,70.119418 C46.0260778,70.6848508 48.0592197,70.9665587 50,70.9665587 C59.0357478,70.9665587 70.0735103,64.8603094 82.9037721,52.445969 C78.9752176,48.4677059 75.235312,45.0976656 71.6962034,42.3241394 L82.3699349,31.6499245 Z M50,17.5 C55.7477825,17.5 61.6931611,19.0471482 67.8751885,22.1038224 L56.4016723,33.576327 C54.1276568,32.8568356 51.9917531,32.5 50,32.5 C41.5008572,32.5 30.3769173,38.9975164 17.0975591,52.4447361 C20.9264188,56.1501928 24.595697,59.2936406 28.0998016,61.8804902 L22.3836108,67.5961637 C18.8889776,64.9456086 15.2981553,61.8350867 11.6073949,58.2682098 L11.5662788,58.3122977 L0.4337212,48.2591309 C18.752099,27.973941 35.0448962,17.5 50,17.5 Z M63.1262971,50.8950791 C63.137294,51.1191436 63.142857,51.3446364 63.142857,51.5714285 C63.142857,59.0667215 57.0667215,65.142857 49.5714285,65.142857 C49.3446364,65.142857 49.1191436,65.137294 48.8950791,65.1262971 L63.1262971,50.8950791 Z M49.5714285,38 C50.3294815,38 51.0730184,38.0621512 51.7972214,38.1816359 L36.1815169,53.7964999 C36.0621099,53.0725246 36,52.3292298 36,51.5714285 C36,44.0761355 42.0761355,38 49.5714285,38 Z"
  }));
};

var FunnelVertical = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("polygon", {
    fill: fill,
    points: "94.681 0 5.921 0 3 8.043 38.677 37.888 38.677 83.404 40.067 86.678 53.858 100 61.572 96.726 61.571 37.902 97.586 8.057"
  }));
};

var FunnelHorizontal = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("polygon", {
    fill: fill,
    points: "94.681 0 5.921 0 3 8.043 38.677 37.888 38.677 83.404 40.067 86.678 53.858 100 61.572 96.726 61.571 37.902 97.586 8.057",
    transform: "rotate(-90 50.293 50)"
  }));
};

var GaugeWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M59.7486448,43.1248427 L60.6187306,43.441528 L62.8323324,48.1886123 L57.0700103,64.0206632 C58.4357361,65.6338843 59.2592593,67.7207701 59.2592593,70 C59.2592593,75.1137477 55.1137477,79.2592593 50,79.2592593 C44.8862523,79.2592593 40.7407407,75.1137477 40.7407407,70 C40.7407407,65.0918489 44.5596153,61.0756437 49.388112,60.7606369 L55.0015605,45.3384445 L59.7486448,43.1248427 Z M50,20 C77.3380951,20 99.5517619,41.9402858 99.9933014,69.1731586 L100,70 L92.5925926,70 C92.5925926,46.4767607 73.5232393,27.4074074 50,27.4074074 C26.7119931,27.4074074 7.78923986,46.0972805 7.4131136,69.2956536 L7.40740741,70 L0,70 C0,42.3857625 22.3857625,20 50,20 Z"
  }));
};

var HeatmapWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("g", {
    fill: fill,
    fillRule: "evenodd"
  }, React.createElement("rect", {
    width: "26",
    height: "26",
    opacity: ".5"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    x: "37",
    opacity: ".5"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    x: "74",
    opacity: ".3"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    y: "37",
    opacity: ".9"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    x: "37",
    y: "37",
    opacity: ".7"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    x: "74",
    y: "37",
    opacity: ".3"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    y: "74"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    x: "37",
    y: "74",
    opacity: ".9"
  }), React.createElement("rect", {
    width: "26",
    height: "26",
    x: "74",
    y: "74",
    opacity: ".7"
  })));
};

var Image = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M89.8110107,11 L100,21.1889893 L100,79.2662284 L89.8110107,89.4552177 L10.1889893,89.4552177 L0,79.2662284 L0,21.1889893 L10.1889893,11 L89.8110107,11 Z M89.8110107,21.1889893 L10.1889893,21.1889893 L10.188,69.312 L27.0008217,55.2902629 L42.7937551,69.2742528 L67.2473295,32.3411565 L89.811,64.705 L89.8110107,21.1889893 Z M27.0008217,27.3023829 C32.9094063,27.3023829 37.6992605,32.0922371 37.6992605,38.0008217 C37.6992605,43.9094063 32.9094063,48.6992605 27.0008217,48.6992605 C21.0922371,48.6992605 16.3023829,43.9094063 16.3023829,38.0008217 C16.3023829,32.0922371 21.0922371,27.3023829 27.0008217,27.3023829 Z"
  }));
};

var UserSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M22.1319897,55.6014406 C29.4388194,42.8284001 38.6831293,37.3646217 49.7353915,39.4212407 C60.6566515,41.4534827 70.0771965,49.6513686 78.0074051,63.9198257 L78.0074051,63.9198257 L78.0550832,64.7934076 L63.9217498,98.3877851 L63,99 L31.3466797,99 L30.3659475,98.1953571 L22.0192678,56.2933438 Z M46,2 C55.3888407,2 63,9.61115925 63,19 C63,28.3888407 55.3888407,36 46,36 C36.6111593,36 29,28.3888407 29,19 C29,9.61115925 36.6111593,2 46,2 Z"
  }));
};

var UserOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M22.1319897,55.6014406 C29.4388194,42.8284001 38.6831293,37.3646217 49.7353915,39.4212407 C60.6566515,41.4534827 70.0771965,49.6513686 78.0074051,63.9198257 L78.0074051,63.9198257 L78.0550832,64.7934076 L63.9217498,98.3877851 L63,99 L31.3466797,99 L30.3659475,98.1953571 L22.0192678,56.2933438 Z M49.3695097,41.3874886 C39.4961715,39.5502452 31.2095945,44.2561428 24.3897248,55.700874 L24.3897248,55.700874 L24.054,56.272 L32.167,97 L62.335,97 L76.022,64.467 L75.584314,63.6983307 C68.1810707,50.8432447 59.5881654,43.4629135 49.8146747,41.4741911 L49.8146747,41.4741911 Z M46,2 C55.3888407,2 63,9.61115925 63,19 C63,28.3888407 55.3888407,36 46,36 C36.6111593,36 29,28.3888407 29,19 C29,9.61115925 36.6111593,2 46,2 Z M46,4 C37.7157288,4 31,10.7157288 31,19 C31,27.2842712 37.7157288,34 46,34 C54.2842712,34 61,27.2842712 61,19 C61,10.7157288 54.2842712,4 46,4 Z"
  }));
};

var UsersSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M21.1319897,55.6014406 C28.4388194,42.8284001 37.6831293,37.3646217 48.7353915,39.4212407 C59.6566515,41.4534827 69.0771965,49.6513686 77.0074051,63.9198257 L77.0074051,63.9198257 L77.0550832,64.7934076 L62.9217498,98.3877851 L62,99 L30.3466797,99 L29.3659475,98.1953571 L21.0192678,56.2933438 Z M68.7510447,47.729505 C72.0620882,45.3432722 75.7861794,44.5187204 79.8578913,45.267476 C86.8387766,46.5512055 92.8406861,51.7127022 97.8716119,60.6581208 L97.8716119,60.6581208 L97.9200944,61.5400142 L89.0432471,82.3916968 L88.1231527,83 L73.5315813,83 L72.6098263,81.6122265 L79.888,64.31 L79.7145944,64.0005905 C76.4141824,58.1853756 72.8800393,53.4261895 69.1162833,49.721171 L69.1162833,49.721171 L68.6446182,49.263534 Z M16.0568632,50.1820721 C17.7791762,49.8829479 19.4214924,49.9518249 20.973248,50.3929826 L20.973248,50.3929826 L21.5112884,51.9392186 C20.7551064,52.989341 20.0167744,54.1141569 19.299899,55.307822 L19.299899,55.307822 L19.056,55.72 L22.9102052,74.8020156 L21.93,76.0000045 L10.2660099,76.0000045 L9.35434634,75.4109375 L3.08833649,61.5098158 L3.14080037,60.5872378 C6.73554022,54.5505788 11.0417531,51.0530757 16.0568632,50.1820721 Z M14.862,34 C19.0041356,34 22.362,37.1340068 22.362,41 C22.362,44.8659932 19.0041356,48 14.862,48 C10.7198644,48 7.362,44.8659932 7.362,41 C7.362,37.1340068 10.7198644,34 14.862,34 Z M77.5,22 C83.2989899,22 88,26.7010101 88,32.5 C88,38.2989899 83.2989899,43 77.5,43 C71.7010101,43 67,38.2989899 67,32.5 C67,26.7010101 71.7010101,22 77.5,22 Z M44,3 C53.3888407,3 61,10.6111593 61,20 C61,29.3888407 53.3888407,37 44,37 C34.6111593,37 27,29.3888407 27,20 C27,10.6111593 34.6111593,3 44,3 Z"
  }));
};

var UsersOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M24.9737401,48.2835287 C32.163891,40.7979864 40.0993604,37.8142371 48.7353915,39.4212407 C56.0543306,40.7831582 62.6992866,44.9141156 68.6733831,51.7854987 C72.0018782,49.3578849 75.7513616,48.5123177 79.8578913,49.267476 C86.8387766,50.5512055 92.8406861,55.7127022 97.8716119,64.6581208 L97.8716119,64.6581208 L97.9200944,65.5400142 L89.0432471,86.3916968 L88.1231527,87 L68.2423727,87 L67.8473365,86.677 L62.9217498,98.3877851 L62,99 L30.3466797,99 L29.375839,98.2397254 L22.8963365,72 L10.2660099,72 L9.35434634,71.4109375 L3.08833649,57.5098158 L3.14080037,56.5872378 C6.73554022,50.5505788 11.0417531,47.0530757 16.0568632,46.1820721 C19.3138968,45.616404 22.2657534,46.3707506 24.8429055,48.4213369 Z M48.3695097,41.3874886 C38.475287,39.546359 29.5325042,44.277398 21.4548744,55.7521115 L21.4548744,55.7521115 L21.1813365,56.143 L24.855821,70.7561819 L24.6973365,70.958 L31.129,97 L61.335,97 L66.8133365,83.977 L66.8103192,83.9577212 L66.868834,83.3722122 L74.888,64.311 L74.6589847,63.902747 C73.3107552,61.5339396 71.9235008,59.3409244 70.4974886,57.3236423 C64.069155,48.375421 56.8399158,43.1071774 48.8146747,41.4741911 L48.8146747,41.4741911 Z M79.4961723,51.2344939 C76.0453504,50.5999151 72.9409468,51.2517101 70.1262086,53.2062783 L70.1262086,53.2062783 L69.988,53.304 L70.3892344,53.814614 C70.9720237,54.5669649 71.5483422,55.345955 72.1182053,56.151581 C73.8057698,58.5029872 75.4358521,61.0922032 77.0074051,63.9198257 L77.0074051,63.9198257 L77.0550832,64.7934076 L68.8953365,84.187 L69.06,85 L87.462,85 L95.885,65.211 L95.580216,64.6860033 C91.0310426,56.9630987 85.7864501,52.528712 79.8531404,51.3041432 L79.8531404,51.3041432 Z M23.0233281,49.5597043 C21.040217,48.1900632 18.8495796,47.7269839 16.3990919,48.1525745 C12.2433272,48.8743305 8.56472955,51.7294073 5.36109065,56.7926912 L5.36109065,56.7926912 L5.127,57.167 L10.912,70 L22.4023365,70 L19.0291593,56.3377121 L19.0863365,56.013 L19.030179,55.7867018 L19.1812492,54.9687346 L19.6969875,54.2333206 C20.7411034,52.7660368 21.802148,51.4047846 22.8805204,50.1494322 L22.8805204,50.1494322 L23.252,49.723 Z M77.5,26 C83.2989899,26 88,30.7010101 88,36.5 C88,42.2989899 83.2989899,47 77.5,47 C71.7010101,47 67,42.2989899 67,36.5 C67,30.7010101 71.7010101,26 77.5,26 Z M77.5,28 C72.8055796,28 69,31.8055796 69,36.5 C69,41.1944204 72.8055796,45 77.5,45 C82.1944204,45 86,41.1944204 86,36.5 C86,31.8055796 82.1944204,28 77.5,28 Z M15.862,29 C20.0041356,29 23.362,32.3578644 23.362,36.5 C23.362,40.6421356 20.0041356,44 15.862,44 C11.7198644,44 8.362,40.6421356 8.362,36.5 C8.362,32.3578644 11.7198644,29 15.862,29 Z M15.862,31 C12.8244339,31 10.362,33.4624339 10.362,36.5 C10.362,39.5375661 12.8244339,42 15.862,42 C18.8995661,42 21.362,39.5375661 21.362,36.5 C21.362,33.4624339 18.8995661,31 15.862,31 Z M44,3 C53.3888407,3 61,10.6111593 61,20 C61,29.3888407 53.3888407,37 44,37 C34.6111593,37 27,29.3888407 27,20 C27,10.6111593 34.6111593,3 44,3 Z M44,5 C35.7157288,5 29,11.7157288 29,20 C29,28.2842712 35.7157288,35 44,35 C52.2842712,35 59,28.2842712 59,20 C59,11.7157288 52.2842712,5 44,5 Z"
  }));
};

var ClickSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M35.470842,28.2259464 L95.3862313,69.319021 L94.9352728,71.4448072 L73.2753512,75.4949151 L84.9452059,92.1166684 L84.6555441,93.7552586 L79.0673861,97.657902 L77.4245441,97.3690018 L65.5997152,80.5268641 L54.0472571,100 L51.8901516,99.6958243 L33.6605452,29.4903401 L35.470842,28.2259464 Z M27.416979,37.0923719 L30.3086997,39.440464 L19.180074,53.5646062 L16.2883533,51.2165141 L27.416979,37.0923719 Z M23.0102825,30.6117501 L23.7216753,34.2483477 L5.71139279,37.3411906 L5,33.704593 L23.0102825,30.6117501 Z M62.0350749,20.1601994 L63.1055804,23.6860663 L45.8654305,28.235422 L44.794925,24.7095551 L62.0350749,20.1601994 Z M9.77566813,10.9771074 L25.3558388,21.3633879 L23.3403369,24.4526895 L7.76016628,14.0664091 L9.77566813,10.9771074 Z M47.2465947,2.89037757 L50.4991037,4.71778816 L41.8289799,20.8212065 L38.5764708,18.993796 L47.2465947,2.89037757 Z M30.6610146,1 L33.0713399,18.5323488 L29.5533576,19.0496426 L27.1430323,1.51729382 L30.6610146,1 Z"
  }));
};

var ClickOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M33.0231796,27.1460023 L95.4572229,69.2167702 L95.0813544,70.9821415 L71.8775691,75.1489741 L84.233311,92.7949385 L83.9735049,94.1698479 L78.2312045,98.19065 L76.8503533,97.9645411 L64.4505691,80.2559741 L52.5429326,100 L50.7117513,99.7403392 L31.4912272,28.191138 L33.0231796,27.1460023 Z M34.1091285,30.2441465 L52.0339973,96.9761273 L65.5083526,74.6417656 L66.18345,74.1811908 L92.3400137,69.4831292 L34.1091285,30.2441465 Z M69.7055691,75.5389741 L67.004366,76.0245288 L65.5825691,78.3809741 L77.9296676,96.0158057 L82.0313108,93.1438043 L69.7055691,75.5389741 Z M25.3445261,34.0294789 L26.4852063,34.9800457 L15.34896,48.3435413 L14.2082798,47.3929745 L25.3445261,34.0294789 Z M22.0755776,28.57641 L22.3299906,30.0392848 L5.254413,33.0089505 L5,31.5460757 L22.0755776,28.57641 Z M56.9010131,19.6825939 L57.2916984,21.1151069 L40.9585372,25.5696054 L40.5678519,24.1370924 L56.9010131,19.6825939 Z M10.0009356,11.6195481 L24.1068476,21.2709616 L23.2683863,22.4964049 L9.1624744,12.8449915 L10.0009356,11.6195481 Z M44.567176,4.45032123 L45.8682101,5.16589002 L37.7016295,20.0142184 L36.4005954,19.2986496 L44.567176,4.45032123 Z M28.8782959,1 L31.1055451,18.0755776 L29.6331843,18.2676247 L27.405935,1.19204707 L28.8782959,1 Z"
  }));
};

var CursorSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("polygon", {
    fill: fill,
    points: "10.472 1 92.28 57.108 91.664 60.011 62.09 65.541 78.024 88.236 77.628 90.473 69.998 95.802 67.755 95.408 51.61 72.411 35.836 99 32.891 98.585 8 2.726"
  }));
};

var CursorOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M8.91888328,0.857260963 L93.0146034,57.5246068 L92.5083263,59.902479 L61.253,65.515 L77.8965219,89.2832906 L77.5465753,91.135229 L69.8119667,96.5510603 L67.9520251,96.2465022 L51.251,72.394 L35.2110726,98.9881697 L32.7445575,98.6384188 L6.85541552,2.26500968 L8.91888328,0.857260963 Z M10.3816053,5.03031557 L34.5255607,94.9151554 L52.6748836,64.8318205 L53.584208,64.2114479 L88.8158692,57.8833799 L10.3816053,5.03031557 Z M58.328,66.04 L54.6899433,66.6943376 L52.774,69.868 L69.4058108,93.6216473 L74.9305312,89.7531965 L58.328,66.04 Z"
  }));
};

var Check = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 30 26"
  }, React.createElement("polygon", {
    fill: fill,
    points: "25.546 .45 30 4.038 12.629 25.599 0 12.809 4.07 8.791 12.196 17.02"
  }));
};

var Line = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 12 3"
  }, React.createElement("line", {
    x1: "208",
    x2: "220",
    y1: "465.5",
    y2: "465.5",
    fill: "none",
    stroke: fill,
    strokeWidth: "3",
    transform: "translate(-208 -464)"
  }));
};

var LineWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M7.92079208,0 L7.92079208,92.0792079 L100,92.0792079 L100,100 L3.96039604,100 L0,96.039604 L0,0 L7.92079208,0 Z M63.0097291,9.84333021 L75.5811881,40.6930693 L80.4941208,30.3807282 L87.6448025,33.7875887 L78.8731441,52.1984797 L71.6301998,51.9895132 L59.860396,23.1029703 L44.5566004,72.7415665 L37.5192998,73.8342217 L27.3326733,59.1673267 L17.6061797,87.4275151 L10.1165926,84.8497191 L22.3845381,49.2061515 L29.3819997,48.2356497 L39.3841584,62.6346535 L55.557493,10.1710494 L63.0097291,9.84333021 Z"
  }));
};

var ChurnMoneyOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("g", {
    fill: fill,
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M4.849 37.23l21.353 21.176 10.374-9.229 2.057.059 24.343 24.279 10.121-8.822 2.064.089 20.78 21.49-2.157 2.085-19.79-20.467-10.102 8.807-2.045-.069-24.333-24.271-10.369 9.227-2.054-.056L2.737 39.361zM65.5 13v5.23a20.846 20.846 0 011.728-.046V13h1.727v5.298c.898.104 1.784.28 2.66.524 1.525.427 2.845 1.016 3.959 1.766l-.995 1.884a13.85 13.85 0 00-3.74-1.688 14.28 14.28 0 00-3.899-.563c-2.44 0-4.276.46-5.51 1.378-1.478.857-2.679 2.509-2.679 3.958 0 1.449.916 2.42 1.844 3.026.928.607 1.525.758 2.546 1.108 1.021.349 2.394.73 4.118 1.145 2.042.491 3.693.976 4.953 1.455a8.135 8.135 0 013.202 2.174c.876.97 1.313 2.283 1.313 3.94 0 1.371-.378 2.62-1.134 3.745-.755 1.126-1.916 2.019-3.48 2.678-.927.391-1.98.666-3.158.826V51h-1.728v-5.199A22.228 22.228 0 0165.5 45.8V51h-1.727v-5.354a17.97 17.97 0 01-3.377-.798C58.5 44.2 57.034 43.347 56 42.286l1.154-1.806c1.008.983 2.347 1.779 4.018 2.387 1.67.608 3.395.912 5.172.912 2.493 0 4.363-.446 5.61-1.339 1.412-.762 2.698-2.185 2.698-3.88 0-1.696-.693-2.397-1.429-3.007-.736-.61-1.92-1.145-2.9-1.495-.982-.349-2.348-.73-4.099-1.145-2.095-.517-3.766-1.015-5.012-1.494-1.247-.479-2.314-.803-3.203-1.787-.888-.983-1.333-2.316-1.333-3.998 0-1.371.372-2.62 1.114-3.745.743-1.126 1.883-2.025 3.422-2.698a11.333 11.333 0 012.56-.752V13H65.5z"
  }), React.createElement("path", {
    d: "M94.557 73.857l1.792 13.257-1.756 1.676-13.428-2.457.54-2.951 11.394 2.084-1.515-11.207z"
  })));
};

var ChurnMoneySolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M5.201 36.875l21.02 20.845 10.023-8.916 2.742.078 24.013 23.95 9.77-8.515 2.751.117 16.544 17.109-.975-7.217 3.964-.536 1.792 13.257-2.342 2.235-13.428-2.457.72-3.935 7.3 1.336-15.131-15.647-9.743 8.495-2.727-.092-23.999-23.938-10.018 8.914-2.738-.074L2.385 39.716l2.816-2.84zM68.118 4.872v5.317c1.594.095 3.162.362 4.702.802 1.811.517 3.41 1.22 4.795 2.11l.373.247.914.629-2.357 4.552-1.165-.764a15.381 15.381 0 00-4.194-1.932c-1.497-.432-2.956-.647-4.38-.647-2.579 0-4.487.455-5.739 1.316l-.182.133-.058.044-.063.037c-1.496.885-2.632 2.56-2.632 3.814 0 1.095.598 1.98 1.676 2.698a6.976 6.976 0 001.401.735l.15.057.25.09 1.186.41c.957.325 2.173.678 3.644 1.055l.45.114.944.235c2.37.591 4.308 1.178 5.82 1.764a11.116 11.116 0 014.371 3.028c1.28 1.448 1.908 3.369 1.908 5.706 0 1.941-.53 3.726-1.582 5.325-1.06 1.61-2.663 2.868-4.775 3.776-1.57.676-3.39 1.09-5.456 1.25l-.001 5.355h-4.022v-5.36c-1.94-.16-3.82-.556-5.64-1.189-2.32-.807-4.177-1.875-5.556-3.215l-.27-.272-.676-.707 2.754-4.397 1.116 1.11c1.087 1.082 2.558 1.973 4.424 2.666 1.886.7 3.829 1.05 5.835 1.05 2.648 0 4.603-.446 5.875-1.286l.186-.129.065-.047.212-.119c1.488-.868 2.48-2.257 2.48-3.619 0-1.372-.318-1.94-1.287-2.76-.66-.558-1.843-1.157-3.136-1.627-1.139-.413-2.754-.873-4.847-1.379-2.416-.608-4.384-1.198-5.91-1.773l-.32-.124-1.033-.4c-1.564-.622-2.454-1.154-3.334-2.146-1.296-1.464-1.932-3.41-1.932-5.78 0-1.936.52-3.718 1.552-5.315 1.041-1.61 2.616-2.876 4.693-3.802 1.379-.615 2.962-1.019 4.748-1.216v-5.42h4.023z"
  }));
};

var ChurnOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("g", {
    fill: fill,
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M4.85 37.23l21.352 21.176 10.374-9.229 2.057.059 24.343 24.279 10.12-8.822 2.065.089 20.78 21.49-2.157 2.085-19.79-20.467-10.102 8.807-2.045-.07-24.333-24.27-10.37 9.227-2.053-.056L2.737 39.361l2.112-2.13zm59.941-7.063c4.304.816 8.04 4.126 11.209 9.932L70.256 54H57.392L54 36.661c2.89-5.144 6.487-7.31 10.791-6.494zm-8.519 6.581l-.165.269L59.038 52h9.88l4.862-11.767-.231-.392c-2.654-4.425-5.61-6.929-8.844-7.65l-.286-.059c-3.13-.593-5.777.827-8.147 4.616zM64 14a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10z"
  }), React.createElement("path", {
    d: "M94.557 73.857l1.792 13.257-1.756 1.676-13.428-2.457.54-2.951 11.394 2.084-1.515-11.207z"
  })));
};

var ChurnSolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M5.201 36.875l21.02 20.845 10.023-8.916 2.742.078 24.013 23.95 9.77-8.515 2.751.117 16.544 17.109-.975-7.217 3.964-.536 1.792 13.257-2.342 2.235-13.428-2.457.72-3.935 7.299 1.335-15.13-15.646-9.743 8.495-2.727-.092-23.999-23.938-10.018 8.914-2.738-.074L2.385 39.716l2.816-2.84zM65.858 22.36c4.954.922 9.242 4.579 12.87 10.929l.246.437.022.405-6.557 15.585-.427.284H57.327l-.455-.373L53 30.187l.052-.32c3.39-5.926 7.679-8.46 12.806-7.507zM64.125 5a7.887 7.887 0 110 15.773 7.887 7.887 0 010-15.773z"
  }));
};

var MoneyOutline = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M47.958 0v14.7a51.496 51.496 0 014.168-.112L52.125 0h4.167v14.85c2.345.264 4.66.722 6.945 1.375 3.833 1.094 7.148 2.603 9.947 4.526l-2.499 4.828a34.474 34.474 0 00-9.397-4.327c-3.332-.962-6.598-1.443-9.797-1.443-6.131 0-10.746 1.177-13.845 3.532-3.715 2.197-6.732 6.43-6.732 10.144 0 3.715 2.3 6.203 4.632 7.757 2.332 1.555 3.832 1.943 6.398 2.839 2.566.895 6.015 1.873 10.347 2.934 5.132 1.26 9.28 2.504 12.446 3.731 3.166 1.227 5.848 3.084 8.047 5.571 2.2 2.487 3.3 5.853 3.3 10.098 0 3.515-.95 6.715-2.85 9.6-1.9 2.885-4.815 5.174-8.747 6.865-2.397 1.03-5.129 1.748-8.195 2.15V100h-4.167l.001-14.624c-.697.027-1.408.04-2.134.04-.682 0-1.36-.014-2.034-.042V100h-4.166V85.01a44.428 44.428 0 01-8.746-2.08C30.281 81.27 26.6 79.083 24 76.364l2.9-4.63c2.532 2.52 5.897 4.56 10.096 6.119a37.053 37.053 0 0012.996 2.338c6.264 0 10.963-1.144 14.095-3.432 3.55-1.953 6.782-5.6 6.782-9.946s-1.74-6.142-3.59-7.707c-1.85-1.565-4.825-2.935-7.29-3.83-2.466-.896-5.899-1.874-10.297-2.935-5.265-1.327-9.464-2.603-12.596-3.83-3.133-1.227-5.815-2.06-8.048-4.58-2.232-2.52-3.349-5.936-3.349-10.247 0-3.515.933-6.715 2.8-9.6 1.866-2.885 4.731-5.19 8.597-6.914 1.985-.886 4.217-1.544 6.695-1.975V0h4.167z"
  }));
};

var MoneySolid = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0zm0 8.974C27.342 8.974 8.974 27.342 8.974 50c0 22.658 18.368 41.026 41.026 41.026 22.658 0 41.026-18.368 41.026-41.026C91.026 27.342 72.658 8.974 50 8.974zm2.564 10.898v6.78c2.033.12 4.032.461 5.997 1.022 2.518.72 4.716 1.72 6.588 3.006l1.166.801-3.005 5.805-1.485-.974a19.613 19.613 0 00-5.349-2.464c-1.909-.55-3.769-.824-5.584-.824-3.453 0-5.962.64-7.55 1.846l-.075.057-.08.047c-1.908 1.128-3.355 3.264-3.355 4.863 0 1.397.763 2.524 2.137 3.44a8.895 8.895 0 001.977 1.01l.319.116 1.513.521c1.342.457 3.083.955 5.218 1.492l1.206.299c3.02.754 5.492 1.502 7.42 2.25 2.186.847 4.05 2.138 5.574 3.861 1.632 1.845 2.432 4.295 2.432 7.276 0 2.475-.675 4.75-2.017 6.789-1.352 2.053-3.395 3.657-6.088 4.815-2.003.861-4.323 1.39-6.957 1.595l-.002 6.827h-5.128v-6.834a29.056 29.056 0 01-7.19-1.516c-3.158-1.099-5.64-2.574-7.43-4.447l-.862-.901 3.512-5.607 1.423 1.416c1.385 1.379 3.26 2.515 5.64 3.399a21.2 21.2 0 007.44 1.338c3.545 0 6.117-.626 7.73-1.803l.082-.06.27-.152c1.898-1.108 3.163-2.878 3.163-4.615 0-1.749-.406-2.474-1.642-3.519-.84-.711-2.35-1.476-3.998-2.074-1.452-.527-3.511-1.114-6.18-1.758-3.301-.832-5.946-1.636-7.945-2.42l-1.317-.51c-1.994-.793-3.13-1.47-4.25-2.737-1.654-1.866-2.464-4.347-2.464-7.368 0-2.47.662-4.742 1.98-6.779 1.326-2.051 3.334-3.666 5.982-4.848 1.759-.784 3.777-1.299 6.055-1.55v-6.911h5.13z"
  }));
};

var MetricWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M28.7791578,71.6228416 L28.7791578,64.8370191 L21.5086337,64.8370191 L21.5086337,27.4544078 L13.7534081,27.4544078 L0,38.9963647 L2.96879733,42.9345653 C3.11016864,43.1365243 3.33232354,43.3334343 3.63526204,43.5252954 C3.93820055,43.7171564 4.28153085,43.8484298 4.66525295,43.9191154 C5.04897506,43.9898011 5.45794204,43.9898011 5.89215389,43.9191154 C6.32636575,43.8484298 6.76562658,43.6414218 7.20993638,43.2980915 L7.20993638,43.2980915 L12.2387155,39.1175401 C12.1983237,39.7032212 12.1680299,40.2838534 12.147834,40.8594365 C12.1276381,41.4350197 12.1175401,42.0055539 12.1175401,42.5710391 L12.1175401,42.5710391 L12.1175401,64.8370191 L3.63526204,64.8370191 L3.63526204,71.6228416 L28.7791578,71.6228416 Z M64.9197213,71.6228416 L64.9197213,66.1699485 C64.9197213,65.261133 64.6268807,64.5290316 64.0411996,63.9736444 C63.4555185,63.4182571 62.6577805,63.1405635 61.6479855,63.1405635 L61.6479855,63.1405635 L53.4080582,63.1405635 C52.4790468,63.1405635 51.4692517,63.231445 50.3786731,63.4132081 C49.2880945,63.5949712 48.187418,63.8575179 47.0766434,64.2008482 L47.0766434,64.2008482 L55.7103908,55.3550439 C56.881753,54.1634858 57.9874785,52.9870746 59.0275674,51.8258104 C60.0676563,50.6645461 60.9815208,49.46289 61.7691609,48.2208422 C62.556801,46.9787943 63.1778249,45.6711098 63.6322327,44.2977885 C64.0866404,42.9244673 64.3138443,41.4299707 64.3138443,39.8142987 C64.3138443,37.93608 63.9856609,36.2143795 63.3292942,34.6491972 C62.6729274,33.0840149 61.7287691,31.7359386 60.4968191,30.6049682 C59.2648692,29.4739978 57.7754216,28.5904271 56.0284762,27.9542563 C54.2815308,27.3180854 52.3174796,27 50.1363223,27 C48.1167323,27 46.2284156,27.2675957 44.4713723,27.802787 C42.714329,28.3379784 41.1541957,29.1508634 39.7909724,30.241442 C38.4277492,31.3320206 37.2866808,32.6952439 36.3677673,34.3311118 C35.4488539,35.9669797 34.82783,37.8855902 34.5046955,40.0869434 L34.5046955,40.0869434 L39.472887,40.965465 C40.7452287,41.167424 41.7247299,41.0866404 42.4113905,40.7231142 C43.0980511,40.359588 43.6534384,39.6224376 44.0775523,38.5116631 C44.4410785,37.4210845 45.1024942,36.50722 46.0617995,35.7700697 C47.0211047,35.0329193 48.1975159,34.6643441 49.591033,34.6643441 C51.3076845,34.6643441 52.5850752,35.1338988 53.4232051,36.0730082 C54.2613349,37.0121175 54.6803999,38.3601939 54.6803999,40.1172372 C54.6803999,41.1876199 54.5491265,42.2024639 54.2865798,43.1617692 C54.0240331,44.1210744 53.6302131,45.0803797 53.1051197,46.0396849 C52.5800263,46.9989902 51.9135615,47.9734424 51.1057255,48.9630415 C50.2978895,49.9526406 49.3486822,50.9927295 48.2581036,52.0833081 L48.2581036,52.0833081 L35.5346865,64.8976068 C34.9288095,65.4428961 34.5046955,66.0487731 34.2623447,66.7152378 C34.0199939,67.3817025 33.8988185,68.0077754 33.8988185,68.5934565 L33.8988185,68.5934565 L33.8988185,71.6228416 L64.9197213,71.6228416 Z M84.4895486,72.1075432 C86.5293345,72.1075432 88.4883369,71.8197516 90.3665556,71.2441684 C92.2447743,70.6685853 93.8957892,69.8052105 95.3196001,68.6540442 C96.7434111,67.5028779 97.8794305,66.058871 98.7276583,64.3220236 C99.5758861,62.5851762 100,60.5453903 100,58.2026659 C100,53.2546703 97.5562961,49.9223468 92.6688882,48.2056952 C93.719075,47.842169 94.6531354,47.3928103 95.4710694,46.8576189 C96.2890033,46.3224275 96.9756639,45.6660608 97.5310512,44.8885186 C98.0864385,44.1109765 98.5055034,43.192063 98.788246,42.1317782 C99.0709886,41.0714935 99.2123599,39.8445925 99.2123599,38.4510754 C99.2123599,36.916187 98.9094214,35.4570332 98.3035444,34.0736141 C97.6976674,32.6901949 96.8090478,31.4733919 95.6376855,30.4232051 C94.4663233,29.3730183 93.0324144,28.5399374 91.3359588,27.9239624 C89.6395032,27.3079875 87.7006968,27 85.5195395,27 C83.4999495,27 81.6116328,27.2675957 79.8545895,27.802787 C78.0975462,28.3379784 76.5374129,29.1508634 75.1741896,30.241442 C73.8109664,31.3320206 72.669898,32.6952439 71.7509846,34.3311118 C70.8320711,35.9669797 70.2110472,37.8855902 69.8879128,40.0869434 L69.8879128,40.0869434 L74.8561042,40.965465 C76.1284459,41.167424 77.1079471,41.0866404 77.7946077,40.7231142 C78.4812683,40.359588 79.0366556,39.6224376 79.4607695,38.5116631 C79.8242957,37.4210845 80.4857114,36.50722 81.4450167,35.7700697 C82.4043219,35.0329193 83.5807331,34.6643441 84.9742502,34.6643441 C86.6909017,34.6643441 87.9682924,35.1338988 88.8064223,36.0730082 C89.6445522,37.0121175 90.0636171,38.3500959 90.0636171,40.0869434 C90.0636171,40.9351712 89.9626376,41.7127133 89.7606786,42.4195698 C89.5587196,43.1264263 89.1497526,43.7272544 88.5337776,44.2220539 C87.9178027,44.7168535 87.04433,45.1056246 85.9133596,45.3883672 C84.7823892,45.6711098 83.2979905,45.8124811 81.4601636,45.8124811 L81.4601636,45.8124811 L81.4601636,52.295365 C83.6413208,52.295365 85.3428254,52.4417853 86.5646774,52.7346259 C87.7865293,53.0274664 88.7003938,53.4465314 89.3062708,53.9918207 C89.9121478,54.53711 90.280723,55.1884277 90.4119964,55.945774 C90.5432697,56.7031203 90.6089064,57.5563971 90.6089064,58.5056044 C90.6089064,59.2326568 90.477633,59.9496112 90.2150863,60.6564677 C89.9525396,61.3633242 89.5637686,61.9944461 89.0487731,62.5498334 C88.5337776,63.1052206 87.8875088,63.5596284 87.1099667,63.9130566 C86.3324245,64.2664849 85.41856,64.443199 84.3683732,64.443199 C82.995052,64.443199 81.7984449,64.0645259 80.778552,63.3071796 C79.758659,62.5498334 78.7943048,61.3330304 77.8854892,59.6567707 C77.4815712,58.9297183 76.8151065,58.4652126 75.8860951,58.2632536 C74.9570837,58.0612946 73.9472887,58.172372 72.8567101,58.5964859 L72.8567101,58.5964859 L68.6761587,60.2929415 C69.3830152,62.3529234 70.2160961,64.1301626 71.1754014,65.6246592 C72.1347067,67.1191558 73.2505301,68.3460568 74.5228719,69.305362 C75.7952136,70.2646673 77.2493184,70.9715238 78.8851863,71.4259315 C80.5210542,71.8803393 82.389175,72.1075432 84.4895486,72.1075432 Z"
  }));
};

var Info = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 30 30"
  }, React.createElement("path", {
    fill: fill,
    d: "M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z M15,3.33333333 C8.55667792,3.33333333 3.33333333,8.55667792 3.33333333,15 C3.33333333,21.4433221 8.55667792,26.6666667 15,26.6666667 C21.4433221,26.6666667 26.6666667,21.4433221 26.6666667,15 C26.6666667,8.55667792 21.4433221,3.33333333 15,3.33333333 Z M16.6666667,13.8333333 L16.6666667,22.9672147 L13.3333333,22.9672147 L13.3333333,13.8333333 L16.6666667,13.8333333 Z M14.959893,7 C15.3074866,7 15.6350267,7.06445672 15.9425134,7.19337017 C16.25,7.32228361 16.5196078,7.50184162 16.7513369,7.7320442 C16.983066,7.96224678 17.1657754,8.22928177 17.2994652,8.53314917 C17.4331551,8.83701657 17.5,9.16390424 17.5,9.51381215 C17.5,9.85451197 17.4331551,10.1744936 17.2994652,10.4737569 C17.1657754,10.7730203 16.983066,11.0354512 16.7513369,11.2610497 C16.5196078,11.4866483 16.25,11.6662063 15.9425134,11.7997238 C15.6350267,11.9332413 15.3074866,12 14.959893,12 C14.6212121,12 14.3048128,11.9332413 14.0106952,11.7997238 C13.7165775,11.6662063 13.4558824,11.4866483 13.2286096,11.2610497 C13.0013369,11.0354512 12.8230838,10.7730203 12.6938503,10.4737569 C12.5646168,10.1744936 12.5,9.85451197 12.5,9.51381215 C12.5,9.16390424 12.5646168,8.83701657 12.6938503,8.53314917 C12.8230838,8.22928177 13.0013369,7.96224678 13.2286096,7.7320442 C13.4558824,7.50184162 13.7165775,7.32228361 14.0106952,7.19337017 C14.3048128,7.06445672 14.6212121,7 14.959893,7 Z",
    id: "path-info"
  }));
};

var ItalicText = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("polygon", {
    fill: fill,
    points: "64.274 100 66.49 90.262 47.394 90.262 66.064 9.738 85.16 9.738 87.377 0 35.753 0 33.537 9.738 52.633 9.738 33.962 90.262 14.866 90.262 12.65 100"
  }));
};

var Json = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M4.55908818,64.7740452 C6.23875225,64.7740452 7.69846031,64.5107645 8.93821236,63.9842032 C10.1779644,63.4576418 11.2077584,62.7177898 12.0275945,61.7646471 C12.8474305,60.8115044 13.4606412,59.6683997 13.8672266,58.3353329 C14.2738119,57.0022662 14.4771046,55.5225622 14.4771046,53.8962208 L14.4771046,53.8962208 L14.4771046,35.319936 L7.71845631,35.319936 L7.71845631,54.0361928 C7.71845631,55.0359928 7.63847231,55.8758248 7.4785043,56.5556889 C7.31853629,57.2355529 7.07858428,57.7854429 6.75864827,58.2053589 C6.43871226,58.6252749 6.03545957,58.925215 5.54889022,59.105179 C5.06232087,59.285143 4.49243485,59.375125 3.83923215,59.375125 C3.3726588,59.375125 2.97273879,59.3384656 2.63947211,59.265147 C2.30620543,59.1918283 2.02626141,59.155169 1.79964007,59.155169 C1.35972805,59.155169 1.01979604,59.2618143 0.779844031,59.475105 C0.539892022,59.6883957 0.399920016,59.9683397 0.359928014,60.314937 L0.359928014,60.314937 L0,64.2541492 C0.799840032,64.4407785 1.56968606,64.5740852 2.30953809,64.6540692 C3.04939012,64.7340532 3.79924015,64.7740452 4.55908818,64.7740452 Z M27.5744851,64.7740452 C29.2274878,64.7740452 30.7038592,64.5240952 32.0035993,64.0241952 C33.3033393,63.5242951 34.396454,62.8377658 35.2829434,61.9646071 C36.1694328,61.0914484 36.8459641,60.0683197 37.3125375,58.895221 C37.7791108,57.7221222 38.0123975,56.4623742 38.0123975,55.1159768 C38.0123975,53.9028861 37.8257682,52.8664267 37.4525095,52.0065987 C37.0792508,51.1467706 36.5893488,50.4169166 35.9828034,49.8170366 C35.3762581,49.2171566 34.6830634,48.7239219 33.9032194,48.3373325 C33.1233753,47.9507432 32.326868,47.6141438 31.5136973,47.3275345 C30.7005266,47.0409251 29.9040192,46.7809771 29.1241752,46.5476905 C28.3443311,46.3144038 27.6511364,46.0577884 27.0445911,45.7778444 C26.4380457,45.4979004 25.9481437,45.1646337 25.574885,44.7780444 C25.2016263,44.391455 25.014997,43.9048857 25.014997,43.3183363 C25.014997,42.3985203 25.324935,41.6686663 25.944811,41.1287742 C26.5646871,40.5888822 27.5078318,40.3189362 28.7742452,40.3189362 C29.5074318,40.3189362 30.1606345,40.4155835 30.7338532,40.6088782 C31.3070719,40.8021729 31.8169699,41.0187962 32.2635473,41.2587483 C32.7101246,41.4987003 33.1100447,41.7153236 33.4633073,41.9086183 C33.81657,42.101913 34.146504,42.1985603 34.4531094,42.1985603 C34.7997067,42.1985603 35.0829834,42.1185763 35.3029394,41.9586083 C35.5228954,41.7986403 35.7328534,41.5586883 35.9328134,41.2387522 L35.9328134,41.2387522 L37.6124775,38.0993801 C37.0925815,37.6194761 36.5026995,37.1895621 35.8428314,36.8096381 C35.1829634,36.4297141 34.4731054,36.1031127 33.7132573,35.829834 C32.9534093,35.5565554 32.1502366,35.34993 31.3037393,35.209958 C30.4572419,35.069986 29.5874159,35 28.6942611,35 C27.0945811,35 25.674865,35.2432847 24.435113,35.729854 C23.1953609,36.2164234 22.1489036,36.8662934 21.2957409,37.6794641 C20.4425782,38.4926348 19.7960408,39.4191162 19.3561288,40.4589082 C18.9162168,41.4987003 18.6962607,42.5651536 18.6962607,43.6582683 C18.6962607,45.0179964 18.8828901,46.1611011 19.2561488,47.0875825 C19.6294075,48.0140639 20.1193095,48.7872426 20.7258548,49.4071186 C21.3324002,50.0269946 22.0222622,50.5268946 22.7954409,50.9068186 C23.5686196,51.2867427 24.3617943,51.6066787 25.174965,51.8666267 C25.9881357,52.1265747 26.7813104,52.363194 27.5544891,52.5764847 C28.3276678,52.7897754 29.0175298,53.0363927 29.6240752,53.3163367 C30.2306205,53.5962807 30.7205226,53.9495434 31.0937812,54.3761248 C31.4670399,54.8027061 31.6536693,55.3559288 31.6536693,56.0357928 C31.6536693,57.2088916 31.3137373,58.0653869 30.6338732,58.6052789 C29.9540092,59.145171 29.0008665,59.415117 27.7744451,59.415117 C26.8679597,59.415117 26.0814504,59.2884756 25.414917,59.035193 C24.7483837,58.7819103 24.1585016,58.5019663 23.6452709,58.1953609 C23.1320403,57.8887556 22.6721322,57.6088116 22.2655469,57.3555289 C21.8589615,57.1022462 21.4557089,56.9756049 21.0557888,56.9756049 C20.7491835,56.9756049 20.4659068,57.0522562 20.2059588,57.2055589 C19.9460108,57.3588616 19.7360528,57.5488236 19.5760848,57.7754449 L19.5760848,57.7754449 L17.5764847,60.934813 C18.1497034,61.5080317 18.8229021,62.0279277 19.5960808,62.4945011 C20.3692595,62.9610745 21.1957608,63.3643271 22.0755849,63.7042591 C22.9554089,64.0441912 23.865227,64.3074718 24.805039,64.4941012 C25.744851,64.6807305 26.6679997,64.7740452 27.5744851,64.7740452 Z M55.4689062,64.7740452 C57.7351196,64.7740452 59.7980404,64.3941212 61.6576685,63.6342731 C63.5172965,62.8744251 65.1069786,61.8246351 66.4267147,60.484903 C67.7464507,59.145171 68.7695794,57.5688196 69.4961008,55.7558488 C70.2226221,53.9428781 70.5858828,51.98327 70.5858828,49.8770246 C70.5858828,47.7841098 70.2226221,45.8311671 69.4961008,44.0181964 C68.7695794,42.2052256 67.7464507,40.6322069 66.4267147,39.2991402 C65.1069786,37.9660735 63.5172965,36.9162834 61.6576685,36.14977 C59.7980404,35.3832567 57.7351196,35 55.4689062,35 C53.2026928,35 51.1364394,35.379924 49.270146,36.139772 C47.4038526,36.8996201 45.8075052,37.9460775 44.4811038,39.2791442 C43.1547024,40.6122109 42.128241,42.1852296 41.4017197,43.9982004 C40.6751983,45.8111711 40.3119376,47.7707792 40.3119376,49.8770246 C40.3119376,51.98327 40.6751983,53.9428781 41.4017197,55.7558488 C42.128241,57.5688196 43.1547024,59.145171 44.4811038,60.484903 C45.8075052,61.8246351 47.4038526,62.8744251 49.270146,63.6342731 C51.1364394,64.3941212 53.2026928,64.7740452 55.4689062,64.7740452 Z M55.4689062,59.175165 C54.1625008,59.175165 52.9994001,58.965207 51.9796041,58.5452909 C50.959808,58.1253749 50.09998,57.5154969 49.40012,56.7156569 C48.7002599,55.9158168 48.1637006,54.9393455 47.7904419,53.7862428 C47.4171832,52.63314 47.2305539,51.3300673 47.2305539,49.8770246 C47.2305539,48.4373125 47.4171832,47.1409052 47.7904419,45.9878024 C48.1637006,44.8346997 48.7002599,43.8582284 49.40012,43.0583883 C50.09998,42.2585483 50.959808,41.6453376 51.9796041,41.2187562 C52.9994001,40.7921749 54.1625008,40.5788842 55.4689062,40.5788842 C56.7619809,40.5788842 57.9150836,40.7921749 58.9282144,41.2187562 C59.9413451,41.6453376 60.7978404,42.2585483 61.4977005,43.0583883 C62.1975605,43.8582284 62.7341198,44.8346997 63.1073785,45.9878024 C63.4806372,47.1409052 63.6672665,48.4373125 63.6672665,49.8770246 C63.6672665,51.3300673 63.4806372,52.63314 63.1073785,53.7862428 C62.7341198,54.9393455 62.1975605,55.9158168 61.4977005,56.7156569 C60.7978404,57.5154969 59.9413451,58.1253749 58.9282144,58.5452909 C57.9150836,58.965207 56.7619809,59.175165 55.4689062,59.175165 Z M80.5238952,64.4541092 L80.5238952,48.8372326 C80.5238952,48.4106512 80.5138972,47.9540759 80.4939012,47.4675065 C80.4739052,46.9809371 80.4372459,46.4777045 80.3839232,45.9578084 L80.3839232,45.9578084 L94.1211758,63.3343331 C94.4677731,63.7475838 94.8177031,64.0375258 95.1709658,64.2041592 C95.5242285,64.3707925 95.9608078,64.4541092 96.4807039,64.4541092 L96.4807039,64.4541092 L100,64.4541092 L100,35.319936 L94.0411918,35.319936 L94.0411918,50.7368526 C94.0411918,51.203426 94.0545224,51.6999933 94.0811838,52.2265547 C94.1078451,52.753116 94.1545024,53.2963407 94.2211558,53.8562288 L94.2211558,53.8562288 L80.3639272,36.3597281 C80.1772979,36.1331067 80.0106645,35.9531427 79.8640272,35.819836 C79.7173899,35.6865294 79.5640872,35.5832167 79.4041192,35.509898 C79.2441512,35.4365794 79.0641872,35.3865893 78.8642272,35.359928 C78.6642671,35.3332667 78.4176498,35.319936 78.1243751,35.319936 L78.1243751,35.319936 L74.565087,35.319936 L74.565087,64.4541092 L80.5238952,64.4541092 Z"
  }));
};

var UnderlineText = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M82.6877618,90 L82.6877618,100 L16.5,100 L16.5,90 L82.6877618,90 Z M27.9620248,0 L27.9620248,47.4210526 L27.9639983,47.9944541 C27.9916271,51.9694432 28.3093589,55.1291866 28.9171935,57.4736842 C29.5539727,59.9298246 30.6249195,62.1578947 32.1300338,64.1578947 C33.8281116,66.4385965 36.134024,68.1578947 39.047771,69.3157895 C41.9615181,70.4736842 45.4638034,71.0526316 49.5546271,71.0526316 C53.6840434,71.0526316 57.195977,70.4824561 60.0904277,69.3421053 C62.9848784,68.2017544 65.3004389,66.4736842 67.0371094,64.1578947 C68.5422237,62.1578947 69.6131705,59.8684211 70.2499497,57.2894737 C70.8867288,54.7105263 71.2051184,51.5087719 71.2051184,47.6842105 L71.2051184,47.6842105 L71.2051184,0 L82.6671432,0 L82.6671432,46.8947368 L82.6632584,47.6320267 C82.6062813,53.0085398 81.9225562,57.7189169 80.6120832,61.7631579 C79.2420432,65.9912281 76.9940198,69.5087719 73.868013,72.3157895 C70.896377,74.9824561 67.4230361,76.9298246 63.4479905,78.1578947 C59.4729449,79.3859649 54.8418237,80 49.5546271,80 C44.1516524,80 39.443346,79.3508772 35.4297076,78.0526316 C31.4160693,76.754386 28.0392102,74.8421053 25.2991302,72.3157895 C22.1731234,69.4385965 19.9251,65.9649123 18.55506,61.8947368 C17.18502,57.8245614 16.5,52.8245614 16.5,46.8947368 L16.5,46.8947368 L16.5,0 L27.9620248,0 Z"
  }));
};

var LockOpen = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M74.496 25.079l.004.422V46.5H86l1.5 1.5v50L86 99.5H10L8.5 98V48l1.5-1.5h59.5v-21c0-11.192-9.977-20.118-21.204-19.999-11.47.122-21.59 8.88-21.793 20.163l-.003.347v6.89h-5V26l.004-.42C21.75 11.43 34.202.65 48.242.502 62.007.355 74.252 11.187 74.496 25.08zM84.5 49.5h-73v47h73v-47zM50 60l1 1v25l-1 1h-4l-1-1V61l1-1h4z"
  }));
};

var LockClosed = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M75.996 25.07l.004.43V47h12.5l1.5 1.5v50l-1.5 1.5h-77L10 98.5v-50l1.5-1.5H23V26.022C23 11.387 35.55.156 49.742.002c13.775-.15 26.011 10.913 26.254 25.069zM87 50H13v47h74V50zM52 60l1 1v25l-1 1h-5l-1-1V61l1-1h5zM49.796 5.001c-11.462.125-21.591 9.089-21.793 20.67l-.003.351V47h43V25.5c0-11.486-9.987-20.62-21.204-20.499z"
  }));
};

var Table = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M96.2962963,0 L100,3.7037037 L100,96.2962963 L96.2962963,100 L3.7037037,100 L0,96.2962963 L0,3.7037037 L3.7037037,0 L96.2962963,0 Z M46.296,75.462 L7.407,75.462 L7.40740741,92.5925926 L46.296,92.592 L46.296,75.462 Z M92.592,75.462 L53.703,75.462 L53.703,92.592 L92.5925926,92.5925926 L92.592,75.462 Z M46.296,50.462 L7.407,50.462 L7.407,68.055 L46.296,68.055 L46.296,50.462 Z M92.592,50.462 L53.703,50.462 L53.703,68.055 L92.592,68.055 L92.592,50.462 Z M46.296,25.462 L7.407,25.462 L7.407,43.055 L46.296,43.055 L46.296,25.462 Z M92.592,25.462 L53.703,25.462 L53.703,43.055 L92.592,43.055 L92.592,25.462 Z"
  }));
};

var Temperature = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: 'evenodd',
    d: "M47.25.5c4.418 0 8 3.546 8 7.92v57.293c5.927 2.916 10 8.97 10 15.967 0 9.842-8.059 17.82-18 17.82s-18-7.978-18-17.82c0-6.997 4.073-13.052 10-15.968V8.42c0-4.374 3.582-7.92 8-7.92zm0 1.98c-3.238 0-5.878 2.54-5.996 5.717l-.004.223v58.52l-1.11.545c-5.402 2.658-8.89 8.116-8.89 14.195 0 8.748 7.163 15.84 16 15.84s16-7.092 16-15.84c0-5.961-3.355-11.326-8.58-14.038l-.31-.156-1.11-.546V8.42c0-3.28-2.686-5.94-6-5.94zm0 31.68a3 3 0 013 3v31.994c5.734 1.341 10 6.44 10 12.526 0 7.108-5.82 12.87-13 12.87s-13-5.762-13-12.87c0-6.086 4.267-11.185 10-12.526V37.16a3 3 0 013-3zm23.5 27.72v1.98h-10v-1.98h10zm0-13.86V50h-10v-1.98h10zm0-13.86v1.98h-10v-1.98h10zm0-13.86v1.98h-10V20.3h10zm0-13.86v1.98h-10V6.44h10z"
  }));
};

var Text = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M14.2149579,85.1149084 L18.0782566,69.8103021 L37.0975731,69.8103021 L41.0104012,85.1149084 L55.2253591,85.1149084 L34.9678058,13 L20.3070827,13 L0,85.1149084 L14.2149579,85.1149084 Z M34.2248638,58.4680535 L20.9509658,58.4680535 L27.4393264,32.9603764 L27.7365032,32.9603764 L34.2248638,58.4680535 Z M72.808321,86.1550272 C75.3178141,86.1550272 77.5218755,85.5028892 79.4205052,84.1986132 C81.3191349,82.8943371 82.9288427,81.1525508 84.2496285,78.9732541 C84.4147268,80.0629024 84.6541192,81.1360409 84.9678058,82.1926696 C85.2814925,83.2492983 85.6364537,84.2233779 86.0326895,85.1149084 L86.0326895,85.1149084 L100,85.1149084 C99.2405481,82.902592 98.6792141,80.6572561 98.315998,78.3789004 C97.9527819,76.1005448 97.7711738,73.6405811 97.7711738,70.9990094 L97.7711738,70.9990094 L97.7711738,49.3051015 C97.7711738,43.2955258 96.0293875,38.6645204 92.5458148,35.4120852 C89.062242,32.15965 84.5302955,30.5334324 78.9499752,30.5334324 C73.0394585,30.5334324 68.2763744,32.1679049 64.6607231,35.4368499 C61.0450718,38.7057949 59.3197953,42.6681526 59.4848935,47.3239227 L59.4848935,47.3239227 L59.6334819,47.6210996 L73.2540862,47.670629 C73.2540862,45.524352 73.6503219,43.8898795 74.4427935,42.7672115 C75.235265,41.6445435 76.4239723,41.0832095 78.0089153,41.0832095 C79.8910352,41.0832095 81.3026251,41.784877 82.243685,43.188212 C83.1847449,44.591547 83.6552749,46.5974905 83.6552749,49.2060426 L83.6552749,49.2060426 L83.6552749,53.564636 L78.3556216,53.564636 C71.685653,53.564636 66.6584118,55.0175004 63.273898,57.9232293 C59.8893842,60.8289582 58.1971273,64.9068846 58.1971273,70.1570084 C58.1971273,75.0108965 59.5261681,78.890705 62.1842496,81.7964339 C64.8423312,84.7021628 68.3836883,86.1550272 72.808321,86.1550272 Z M76.8697375,75.5557207 C75.4498927,75.5557207 74.3272247,74.9943867 73.5017335,73.8717187 C72.6762424,72.7490507 72.2634968,71.2961862 72.2634968,69.5131253 C72.2634968,67.2347697 72.7422817,65.3526498 73.6998514,63.8667657 C74.6574212,62.3808816 76.2093446,61.6379396 78.3556216,61.6379396 L78.3556216,61.6379396 L83.6552749,61.6379396 L83.6552749,71.4943041 C82.9618623,72.6830114 82.0125475,73.657091 80.8073304,74.4165428 C79.6021133,75.1759947 78.2895823,75.5557207 76.8697375,75.5557207 Z"
  }));
};

var PieWidget = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M47.1355052,3 C47.088247,20.3443929 47.088247,36.056228 47.1355052,50.1355052 C47.2324767,62.3097224 47.2324767,78.0215575 47.1355052,97.2710104 C21.1032845,97.2710104 1.95399252e-13,76.1677259 1.95399252e-13,50.1355052 C1.95399252e-13,24.1032845 21.1032845,3 47.1355052,3 Z M94.1016172,27.4582178 C98.7501257,34.7622263 100,43.3556336 100,50.1355052 C100,76.1677259 78.8967152,97.2710104 52.8644945,97.2710104 C52.767523,78.0215575 52.767523,63.8809059 52.8644945,54.8490557 C62.4226298,48.5634011 76.1683373,39.4331218 94.1016172,27.4582178 Z M52.7917658,3 C67.8383827,3 82.1309524,10.172009 90.1392888,21.6378575 C79.895769,28.9932192 67.4465947,37.549725 52.7917658,47.3073749 C52.8696499,35.4909211 52.8696499,20.7217961 52.7917658,3 Z"
  }));
};

var Plus = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("polygon", {
    fill: fill,
    points: "57.875 100 57.875 57.329 98.337 57.329 98.337 42.47 57.875 42.47 57.875 0 41.911 0 41.911 42.47 1.65 42.47 1.65 57.329 41.911 57.329 41.911 100"
  }));
};

var Search = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M36.9565217,2.48689958e-13 C57.3670451,2.48689958e-13 73.9130435,16.5459984 73.9130435,36.9565217 C73.9130435,44.9378776 71.3829414,52.3282964 67.0810307,58.3694848 L94.9853565,86.2746207 L86.2746207,94.9853565 L58.3694848,67.0810307 C52.3282964,71.3829414 44.9378776,73.9130435 36.9565217,73.9130435 C16.5459984,73.9130435 -2.0250468e-12,57.3670451 -2.0250468e-12,36.9565217 C-2.0250468e-12,16.5459984 16.5459984,2.48689958e-13 36.9565217,2.48689958e-13 Z M36.9565217,8.21256039 C21.0816702,8.21256039 8.21256039,21.0816702 8.21256039,36.9565217 C8.21256039,52.8313732 21.0816702,65.7004831 36.9565217,65.7004831 C52.8313732,65.7004831 65.7004831,52.8313732 65.7004831,36.9565217 C65.7004831,21.0816702 52.8313732,8.21256039 36.9565217,8.21256039 Z"
  }));
};

var Squares = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    opacity: "0.600000024"
  }, React.createElement("g", {
    transform: "translate(-20.000000, -77.000000)",
    fill: fill
  }, React.createElement("path", {
    d: "M21,77 L25.6666667,77 C26.2189514,77 26.6666667,77.4477153 26.6666667,78 L26.6666667,82.6666667 C26.6666667,83.2189514 26.2189514,83.6666667 25.6666667,83.6666667 L21,83.6666667 C20.4477153,83.6666667 20,83.2189514 20,82.6666667 L20,78 C20,77.4477153 20.4477153,77 21,77 Z M21,86.3333333 L25.6666667,86.3333333 C26.2189514,86.3333333 26.6666667,86.7810486 26.6666667,87.3333333 L26.6666667,92 C26.6666667,92.5522847 26.2189514,93 25.6666667,93 L21,93 C20.4477153,93 20,92.5522847 20,92 L20,87.3333333 C20,86.7810486 20.4477153,86.3333333 21,86.3333333 Z M30.3333333,77 L35,77 C35.5522847,77 36,77.4477153 36,78 L36,82.6666667 C36,83.2189514 35.5522847,83.6666667 35,83.6666667 L30.3333333,83.6666667 C29.7810486,83.6666667 29.3333333,83.2189514 29.3333333,82.6666667 L29.3333333,78 C29.3333333,77.4477153 29.7810486,77 30.3333333,77 Z M30.3333333,86.3333333 L35,86.3333333 C35.5522847,86.3333333 36,86.7810486 36,87.3333333 L36,92 C36,92.5522847 35.5522847,93 35,93 L30.3333333,93 C29.7810486,93 29.3333333,92.5522847 29.3333333,92 L29.3333333,87.3333333 C29.3333333,86.7810486 29.7810486,86.3333333 30.3333333,86.3333333 Z",
    id: "Combined-Shape"
  }))));
};

var Actions = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M50 37c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13zm37 0c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13zm-74 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 57.18 0 50s5.82-13 13-13z"
  }));
};

var Settings = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M60 74c5.408 0 10.045 3.302 12.004 8H98a2 2 0 012 2v6a2 2 0 01-2 2H72.003c-1.959 4.698-6.595 8-12.003 8s-10.044-3.302-12.003-8H2a2 2 0 01-2-2v-6a2 2 0 012-2h45.996c1.96-4.698 6.596-8 12.004-8zM29 37c5.408 0 10.045 3.302 12.004 8H98a2 2 0 012 2v6a2 2 0 01-2 2H41.003c-1.959 4.698-6.595 8-12.003 8s-10.044-3.302-12.003-8H2a2 2 0 01-2-2v-6a2 2 0 012-2h14.996c1.96-4.698 6.596-8 12.004-8zM72 0c5.408 0 10.045 3.302 12.004 8H98a2 2 0 012 2v6a2 2 0 01-2 2H84.003c-1.959 4.698-6.595 8-12.003 8s-10.044-3.302-12.003-8H2a2 2 0 01-2-2v-6a2 2 0 012-2h57.996C61.956 3.302 66.592 0 72 0z"
  }));
};

var Share = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M67.4983238,3.85 L100,36.0622469 L100,43.6547463 L67.4983238,75.8669931 L58.2510185,72.0707434 L58.251,52.934 L57.7341052,52.9278163 L56.3359518,52.9159266 L54.9728185,52.9106774 L53.6447278,52.9120628 L52.351702,52.9200768 L51.0937635,52.9347135 L49.8709346,52.9559671 L48.6832376,52.9838315 L47.5306949,53.0183009 L46.4133287,53.0593693 L45.3311616,53.1070308 L44.2842157,53.1612794 L43.2725134,53.2221093 L42.2960771,53.2895146 L41.3549291,53.3634892 L40.4490917,53.4440272 L39.5785873,53.5311229 C39.4364489,53.5461849 39.2957837,53.56152 39.156592,53.5771279 L39.156592,53.5771279 L38.339129,53.6740487 L37.5570548,53.7775122 L37.1792954,53.8316956 C29.5357189,54.9577681 20.9944598,64.129803 19.8886824,72.1155023 C19.140506,77.5186802 20.1946071,84.738081 23.0985581,93.7285577 L23.0985581,93.7285577 L20.0113507,96.1437718 C12.359807,91.3947395 6.99437779,85.661589 3.9721588,78.9461766 C-0.743696428,68.467481 -1.33604912,58.7247205 2.60075091,48.7468862 C6.39888862,39.120492 15.0926987,32.4679614 26.5651063,28.9231163 L26.5651063,28.9231163 L26.8703833,28.8308624 C27.1796001,28.7394643 27.5006375,28.6506333 27.8335112,28.5643636 L27.8335112,28.5643636 L28.5150452,28.3952377 L29.2281704,28.232932 L29.9729147,28.0774364 C30.0996753,28.0520874 30.2277544,28.0270217 30.3571528,28.0022392 L30.3571528,28.0022392 L31.1493778,27.8569398 L31.9732914,27.7184253 C32.1132526,27.6959044 32.2545353,27.6736657 32.39714,27.6517092 L32.39714,27.6517092 L33.2686385,27.5233531 C33.4165339,27.502524 33.5657526,27.4819765 33.7162952,27.4617105 L33.7162952,27.4617105 L34.635441,27.3434901 L35.5863863,27.2320141 C35.9086712,27.1959785 36.2362605,27.1610652 36.5691591,27.1272726 L36.5691591,27.1272726 L37.583787,27.0292554 L38.6302979,26.9379525 L39.7087194,26.8533537 L40.8190794,26.775449 L41.9614056,26.7042282 L43.1357259,26.6396813 L44.3420679,26.5817982 L45.5804595,26.5305688 L46.8509285,26.485983 L48.1535025,26.4480308 L49.4882094,26.4167019 L50.8550769,26.3919864 L52.9657401,26.3672911 C53.2042853,26.3653713 53.4441734,26.363726 53.685405,26.362355 L53.685405,26.362355 L55.8927793,26.3574164 L58.1727962,26.3672557 C58.1990657,26.3674509 58.2253492,26.367649 58.2516467,26.36785 L58.2510185,7.6462497 L67.4983238,3.85 Z"
  }));
};

var Warning = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fill: fill,
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M54.1049758,0 L100,93.2522069 L95.8950242,100 L4.10497576,100 L0,93.2522069 L45.8950242,0 L54.1049758,0 Z M50,12.511712 L11.5307907,90.6747793 L88.4682914,90.6747793 L50,12.511712 Z M49.8729497,69.3429174 C50.96141,69.3429174 51.9870745,69.5519668 52.9499432,69.9700657 C53.912812,70.3881646 54.7570664,70.9504355 55.4827066,71.6568785 C56.2083468,72.3633214 56.7804862,73.185102 57.1991248,74.1222202 C57.6177633,75.0593384 57.8270826,76.061334 57.8270826,77.1282071 C57.8270826,78.2239145 57.6177633,79.2475359 57.1991248,80.1990714 C56.7804862,81.1506068 56.2083468,81.9868045 55.4827066,82.7076647 C54.7570664,83.4285249 53.912812,83.9907958 52.9499432,84.3944775 C51.9870745,84.7981592 50.96141,85 49.8729497,85 C48.8123987,85 47.8216207,84.7981592 46.9006159,84.3944775 C45.979611,83.9907958 45.1632658,83.4285249 44.4515802,82.7076647 C43.7398946,81.9868045 43.1817099,81.1506068 42.7770259,80.1990714 C42.372342,79.2475359 42.17,78.2239145 42.17,77.1282071 C42.17,76.061334 42.372342,75.0593384 42.7770259,74.1222202 C43.1817099,73.185102 43.7398946,72.3633214 44.4515802,71.6568785 C45.1632658,70.9504355 45.979611,70.3881646 46.9006159,69.9700657 C47.8216207,69.5519668 48.8123987,69.3429174 49.8729497,69.3429174 Z M55.2175688,35 L55.2175688,63.6019871 L44.7795138,63.6019871 L44.7795138,35 L55.2175688,35 Z",
    id: "warning"
  }))));
};

var Move = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 100 100"
  }, React.createElement("path", {
    fill: fill,
    d: "M66.9629822,56.4247219 L82.672,72.134 L93.1203869,61.6853938 L99.4476348,64.3071851 L99.447,64.619 L99.9943889,64.8461543 L100.000145,96.2937527 L96.2946884,99.9992094 L64.84709,99.9934532 L64.624,99.454 L64.3003358,99.454484 L61.6785446,93.1272361 L72.128,82.678 L56.4187925,66.9689116 L56.4190126,61.3455638 L61.3396345,56.424942 L66.9629822,56.4247219 Z M38.6603655,56.424942 L43.5809874,61.3455638 L43.5812075,66.9689116 L27.872,82.678 L38.3214554,93.1272361 L35.6996642,99.454484 L35.375,99.454 L35.15291,99.9934532 L3.70531163,99.9992094 L-0.000145014348,96.2937527 L0.00561111533,64.8461543 L0.552,64.619 L0.552365236,64.3071851 L6.87961313,61.6853938 L17.328,72.134 L33.0370178,56.4247219 L38.6603655,56.424942 Z M3.70531163,0.000790642822 L35.15291,0.0065467725 L37.7747013,6.33379467 L27.325,16.782 L43.0307947,32.4884603 L43.0305746,38.111808 L38.1099528,43.0324299 L32.486605,43.0326499 L16.78,27.327 L6.33285901,37.775637 L0.00561111533,35.1538457 L-0.000145014347,3.70624729 L3.70531163,0.000790642822 Z M96.2946884,0.000790642822 L100.000145,3.70624729 L99.9943889,35.1538457 L93.667141,37.775637 L83.219,27.327 L67.513395,43.0326499 L61.8900472,43.0324299 L56.9694254,38.111808 L56.9692053,32.4884603 L72.674,16.782 L62.2252987,6.33379467 L64.84709,0.0065467725 L96.2946884,0.000790642822 Z",
    id: "move"
  }));
};

var Zoom = function (_a) {
  var width = _a.width,
      height = _a.height,
      opacity = _a.opacity,
      fill = _a.fill;
  return React.createElement("svg", {
    width: width,
    height: height,
    opacity: opacity,
    viewBox: "0 0 15 15"
  }, React.createElement("path", {
    fill: fill,
    d: "M6.10169492,0 C9.47156796,0 12.2033898,2.73182187 12.2033898,6.10169492 C12.2033898,7.47220018 11.7515477,8.73717206 10.988705,9.75576907 L15,13.767927 L13.767927,15 L9.75576907,10.988705 C8.73717206,11.7515477 7.47220018,12.2033898 6.10169492,12.2033898 C2.73182187,12.2033898 0,9.47156796 0,6.10169492 C0,2.73182187 2.73182187,0 6.10169492,0 Z M6.10169492,1.3559322 C3.48068254,1.3559322 1.3559322,3.48068254 1.3559322,6.10169492 C1.3559322,8.72270729 3.48068254,10.8474576 6.10169492,10.8474576 C8.72270729,10.8474576 10.8474576,8.72270729 10.8474576,6.10169492 C10.8474576,3.48068254 8.72270729,1.3559322 6.10169492,1.3559322 Z M6.6405,3.816 L6.6405,5.598 L8.3055,5.598 L8.3055,6.597 L6.6405,6.597 L6.6405,8.388 L5.5065,8.388 L5.5065,6.597 L3.8505,6.597 L3.8505,5.598 L5.5065,5.598 L5.5065,3.816 L6.6405,3.816 Z"
  }));
};

var getIcon = function (type) {
  switch (type) {
    case 'arrow-down':
      return ArrowDown;

    case 'arrow-up':
      return ArrowUp;

    case 'area-widget':
      return LineWidget$1;

    case 'bar-widget-horizontal':
      return BarHorizontal;

    case 'bar-widget-vertical':
      return BarVertical;

    case 'button-arrow':
      return ButtonArrow;

    case 'button-arrow-left':
      return ButtonArrowLeft;

    case 'caret-down':
      return CaretDown;

    case 'caret-up':
      return CaretUp;

    case 'caret-left':
      return CaretLeft;

    case 'caret-right':
      return CaretRight;

    case 'check':
      return Check;

    case 'close':
      return Close;

    case 'choropleth-widget':
      return ChoroplethWidget;

    case 'drag':
      return Drag;

    case 'date-picker':
      return DatePicker;

    case 'donut-widget':
      return DonutWidget;

    case 'line':
      return Line;

    case 'line-widget':
      return LineWidget;

    case 'info':
      return Info;

    case 'json':
      return Json;

    case 'brand':
      return Brand;

    case 'question-mark':
      return QuestionMark;

    case 'click-solid':
      return ClickSolid;

    case 'click-outline':
      return ClickOutline;

    case 'cursor-solid':
      return CursorSolid;

    case 'cursor-outline':
      return CursorOutline;

    case 'corner-tick':
      return CornerTick;

    case 'eye-solid':
      return EyeSolid;

    case 'eye-outline':
      return EyeOutline;

    case 'eye-slash-solid':
      return EyeSlashSolid;

    case 'funnel-widget-horizontal':
      return FunnelHorizontal;

    case 'funnel-widget-vertical':
      return FunnelVertical;

    case 'gauge-widget':
      return GaugeWidget;

    case 'heatmap-widget':
      return HeatmapWidget;

    case 'image':
      return Image;

    case 'user-solid':
      return UserSolid;

    case 'user-outline':
      return UserOutline;

    case 'users-solid':
      return UsersSolid;

    case 'users-outline':
      return UsersOutline;

    case 'churn-money-outline':
      return ChurnMoneyOutline;

    case 'churn-money-solid':
      return ChurnMoneySolid;

    case 'churn-outline':
      return ChurnOutline;

    case 'churn-solid':
      return ChurnSolid;

    case 'metric-widget':
      return MetricWidget;

    case 'money-outline':
      return MoneyOutline;

    case 'money-solid':
      return MoneySolid;

    case 'lock-open':
      return LockOpen;

    case 'lock-closed':
      return LockClosed;

    case 'plus':
      return Plus;

    case 'pie-widget':
      return PieWidget;

    case 'temperature':
      return Temperature;

    case 'text':
      return Text;

    case 'search':
      return Search;

    case 'table-widget':
      return Table;

    case 'actions':
      return Actions;

    case 'settings':
      return Settings;

    case 'delete':
      return Delete;

    case 'clone':
      return Clone;

    case 'resize':
      return Resize;

    case 'share':
      return Share;

    case 'italic-text':
      return ItalicText;

    case 'bold-text':
      return BoldText;

    case 'underline-text':
      return UnderlineText;

    case 'align-left':
      return AlignCenter;

    case 'align-center':
      return AlignLeft;

    case 'align-right':
      return AlignRight;

    case 'warning':
      return Warning;

    case 'move':
      return Move;

    case 'zoom':
      return Zoom;

    case 'squares':
      return Squares;
  }
};

var Icon = function (_a) {
  var _b = _a.width,
      width = _b === void 0 ? 15 : _b,
      _c = _a.height,
      height = _c === void 0 ? 15 : _c,
      _d = _a.opacity,
      opacity = _d === void 0 ? 1 : _d,
      _e = _a.fill,
      fill = _e === void 0 ? colors.white['500'] : _e,
      type = _a.type;
  return React.createElement(getIcon(type), {
    fill: fill,
    opacity: opacity,
    width: width,
    height: height
  });
};

var Icons = ['arrow-up', 'arrow-down', 'align-left', 'align-center', 'align-right', 'area-widget', 'bar-widget-horizontal', 'bar-widget-vertical', 'button-arrow', 'button-arrow-left', 'brand', 'check', 'close', 'caret-down', 'caret-up', 'caret-left', 'caret-right', 'corner-tick', 'choropleth-widget', 'drag', 'date-picker', 'question-mark', 'cursor-solid', 'cursor-outline', 'click-solid', 'click-outline', 'donut-widget', 'eye-solid', 'eye-outline', 'eye-slash-solid', 'funnel-widget-vertical', 'funnel-widget-horizontal', 'gauge-widget', 'heatmap-widget', 'image', 'user-solid', 'user-outline', 'users-solid', 'users-outline', 'line', 'line-widget', 'info', 'italic-text', 'underline-text', 'bold-text', 'json', 'churn-money-outline', 'churn-money-solid', 'churn-outline', 'churn-solid', 'money-outline', 'money-solid', 'metric-widget', 'lock-open', 'lock-closed', 'table-widget', 'temperature', 'text', 'pie-widget', 'plus', 'search', 'actions', 'settings', 'squares', 'delete', 'clone', 'resize', 'share', 'warning', 'move', 'zoom'];

export { Icon, Icons };
//# sourceMappingURL=index.esm.js.map
